/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 2151:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(5772);
var THEMES = {
  MP: 'mercadopago',
  ML: 'mercadolibre'
  // ME: 'mercadoenvios',
  // MS: 'mercadoshops',
  // MA: 'mercadoads',
  // MC: 'mercadocreditos',
};
var THEMES_FLATNAMES = Object.values(THEMES);
module.exports = {
  THEMES: THEMES,
  THEMES_FLATNAMES: THEMES_FLATNAMES
};

/***/ }),

/***/ 5772:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.object.values.js");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/create fake namespace object */
/******/ 	(() => {
/******/ 		var getProto = Object.getPrototypeOf ? (obj) => (Object.getPrototypeOf(obj)) : (obj) => (obj.__proto__);
/******/ 		var leafPrototypes;
/******/ 		// create a fake namespace object
/******/ 		// mode & 1: value is a module id, require it
/******/ 		// mode & 2: merge all properties of value into the ns
/******/ 		// mode & 4: return value when already ns object
/******/ 		// mode & 16: return value when it's Promise-like
/******/ 		// mode & 8|1: behave like require
/******/ 		__webpack_require__.t = function(value, mode) {
/******/ 			if(mode & 1) value = this(value);
/******/ 			if(mode & 8) return value;
/******/ 			if(typeof value === 'object' && value) {
/******/ 				if((mode & 4) && value.__esModule) return value;
/******/ 				if((mode & 16) && typeof value.then === 'function') return value;
/******/ 			}
/******/ 			var ns = Object.create(null);
/******/ 			__webpack_require__.r(ns);
/******/ 			var def = {};
/******/ 			leafPrototypes = leafPrototypes || [null, getProto({}), getProto([]), getProto(getProto)];
/******/ 			for(var current = mode & 2 && value; typeof current == 'object' && !~leafPrototypes.indexOf(current); current = getProto(current)) {
/******/ 				Object.getOwnPropertyNames(current).forEach((key) => (def[key] = () => (value[key])));
/******/ 			}
/******/ 			def['default'] = () => (value);
/******/ 			__webpack_require__.d(ns, def);
/******/ 			return ns;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ heroSection)
});

;// external "@babel/runtime/helpers/jsx"
const jsx_namespaceObject = require("@babel/runtime/helpers/jsx");
var jsx_default = /*#__PURE__*/__webpack_require__.n(jsx_namespaceObject);
;// external "@babel/runtime/helpers/defineProperty"
const defineProperty_namespaceObject = require("@babel/runtime/helpers/defineProperty");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_namespaceObject);
;// external "@babel/runtime/helpers/objectSpread2"
const objectSpread2_namespaceObject = require("@babel/runtime/helpers/objectSpread2");
var objectSpread2_default = /*#__PURE__*/__webpack_require__.n(objectSpread2_namespaceObject);
;// external "@babel/runtime/helpers/objectWithoutProperties"
const objectWithoutProperties_namespaceObject = require("@babel/runtime/helpers/objectWithoutProperties");
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties_namespaceObject);
;// external "core-js/modules/es.symbol.js"
const es_symbol_js_namespaceObject = require("core-js/modules/es.symbol.js");
;// external "core-js/modules/es.symbol.description.js"
const es_symbol_description_js_namespaceObject = require("core-js/modules/es.symbol.description.js");
;// external "core-js/modules/es.array.concat.js"
const es_array_concat_js_namespaceObject = require("core-js/modules/es.array.concat.js");
;// external "core-js/modules/es.array.includes.js"
const es_array_includes_js_namespaceObject = require("core-js/modules/es.array.includes.js");
;// external "core-js/modules/es.array.slice.js"
const es_array_slice_js_namespaceObject = require("core-js/modules/es.array.slice.js");
;// external "core-js/modules/es.function.name.js"
const es_function_name_js_namespaceObject = require("core-js/modules/es.function.name.js");
;// external "core-js/modules/es.string.includes.js"
const es_string_includes_js_namespaceObject = require("core-js/modules/es.string.includes.js");
;// external "react"
const external_react_namespaceObject = require("react");
;// external "prop-types"
const external_prop_types_namespaceObject = require("prop-types");
;// external "classnames"
const external_classnames_namespaceObject = require("classnames");
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_namespaceObject);
;// external "@andes-landings/title"
const title_namespaceObject = require("@andes-landings/title");
;// external "@andes-landings/layout"
const layout_namespaceObject = require("@andes-landings/layout");
;// external "@andes-landings/image-container"
const image_container_namespaceObject = require("@andes-landings/image-container");
;// external "@andes-landings/background"
const background_namespaceObject = require("@andes-landings/background");
;// external "@andes-landings/actions"
const actions_namespaceObject = require("@andes-landings/actions");
;// external "@andes-landings/bullets"
const bullets_namespaceObject = require("@andes-landings/bullets");
;// external "@andes-landings/typography"
const typography_namespaceObject = require("@andes-landings/typography");
;// external "@pog-ui-landings-library/framework"
const framework_namespaceObject = require("@pog-ui-landings-library/framework");
// EXTERNAL MODULE: ./utils/constants/themes.js
var themes = __webpack_require__(2151);
;// external "@pog-ui-landings-library/icons"
const icons_namespaceObject = require("@pog-ui-landings-library/icons");
var icons_default = /*#__PURE__*/__webpack_require__.n(icons_namespaceObject);
;// external "react/jsx-runtime"
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
;// ./components/atoms/icon/src/Icon.js




/* istanbul ignore file */





var namespace = 'pog-ui-svg';
var Icon = function Icon(_ref) {
  var className = _ref.className,
    name = _ref.name,
    options = _ref.options,
    inverted = _ref.inverted;
  var IconElement = (icons_default())["".concat(name)];
  var getColor = function getColor() {
    if (inverted === true) {
      return '#fff';
    }

    // This is the accent color enabled in AL for the Mercado Pago theme icons
    if (inverted === false) {
      return 'rgba(0,0,0,0.9)';
    }
    return options === null || options === void 0 ? void 0 : options.color;
  };
  var borderStyles = {
    borderColor: getColor()
  };
  if (!IconElement) {
    return null;
  }
  return /*#__PURE__*/jsx_default()("div", {
    className: external_classnames_default()(namespace, className, defineProperty_default()({}, "".concat(namespace, "--circle"), options === null || options === void 0 ? void 0 : options.border)),
    style: options !== null && options !== void 0 && options.border ? borderStyles : null
  }, void 0, /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(IconElement, objectSpread2_default()(objectSpread2_default()({}, objectSpread2_default()(objectSpread2_default()({}, options), {}, {
    color: getColor()
  })), {}, {
    className: external_classnames_default()(defineProperty_default()(defineProperty_default()({}, "".concat(namespace, "-icon"), true), "".concat(className, "-icon"), !!className))
  })));
};
Icon.defaultProps = {
  className: '',
  options: {},
  inverted: null
};
/* harmony default export */ const src_Icon = (Icon);
;// external "@babel/runtime/helpers/slicedToArray"
const slicedToArray_namespaceObject = require("@babel/runtime/helpers/slicedToArray");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray_namespaceObject);
;// external "core-js/modules/es.date.to-string.js"
const es_date_to_string_js_namespaceObject = require("core-js/modules/es.date.to-string.js");
;// ./utils/src/datesResolver.js

/* istanbul ignore file */

function getDateWithHour(hour, minutes) {
  var date = new Date();
  date.setHours(hour);
  date.setMinutes(minutes);
  return date;
}
function getDateUTC() {
  var originalDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var utcHours = new Date().getTimezoneOffset() / 60;
  var date = new Date(originalDate);
  var resetHours = date.getHours() + utcHours;
  date.setHours(resetHours);
  return date;
}
;// ./components/atoms/sameDay/src/SameDay.js





/* istanbul ignore file */






var SameDay_namespace = 'pog-ui-same-day';

/**
 * Component
 */

var SameDay = function SameDay(_ref) {
  var className = _ref.className,
    isMobile = _ref.isMobile,
    sameDay = _ref.sameDay,
    inverted = _ref.inverted,
    thumb = _ref.thumb;
  var _useState = (0,external_react_namespaceObject.useState)(sameDay),
    _useState2 = slicedToArray_default()(_useState, 2),
    sameDaySt = _useState2[0],
    setSameDaySt = _useState2[1];
  var _ref2 = sameDay || {},
    textVariant = _ref2.textVariant;
  var isTextVariant = (textVariant === null || textVariant === void 0 ? void 0 : textVariant.today) && (textVariant === null || textVariant === void 0 ? void 0 : textVariant.tomorrow) && (textVariant === null || textVariant === void 0 ? void 0 : textVariant.nextWeek);
  (0,external_react_namespaceObject.useEffect)(function () {
    /* istanbul ignore next */
    if (sameDay) {
      var _sameDay$textVariant;
      var date = new Date();
      var day = date.getDay();
      var _ref3 = sameDay.conditions || {},
        today = _ref3.today,
        tomorrow = _ref3.tomorrow,
        nextWeek = _ref3.nextWeek;
      var firstTimeCondition = getDateWithHour(today === null || today === void 0 ? void 0 : today.hours, today === null || today === void 0 ? void 0 : today.minutes);
      var secondTimeCondition = getDateWithHour(tomorrow === null || tomorrow === void 0 ? void 0 : tomorrow.hours, tomorrow === null || tomorrow === void 0 ? void 0 : tomorrow.minutes);
      var thirdTimeCondition = getDateWithHour(nextWeek === null || nextWeek === void 0 ? void 0 : nextWeek.hours, nextWeek === null || nextWeek === void 0 ? void 0 : nextWeek.minutes);

      // Default Today > From Monday to friday 00:00 hs to 17:30 hs
      sameDaySt.text = (_sameDay$textVariant = sameDay.textVariant) === null || _sameDay$textVariant === void 0 ? void 0 : _sameDay$textVariant.today;

      // Tomorrow > From monday to Thursday from: 17:30 to 23:59 hs AND Sunday all day.
      if (day >= 1 && day <= 4 && date > secondTimeCondition && date < thirdTimeCondition || day === 0 && date > firstTimeCondition && date < thirdTimeCondition) {
        var _sameDay$textVariant2;
        sameDaySt.text = (_sameDay$textVariant2 = sameDay.textVariant) === null || _sameDay$textVariant2 === void 0 ? void 0 : _sameDay$textVariant2.tomorrow;
      }

      // Monday > For friday > 17:30 hs and thursday all day.
      if (day === 5 && date > secondTimeCondition && date < thirdTimeCondition || day === 6 && date > firstTimeCondition && date < thirdTimeCondition) {
        var _sameDay$textVariant3;
        sameDaySt.text = (_sameDay$textVariant3 = sameDay.textVariant) === null || _sameDay$textVariant3 === void 0 ? void 0 : _sameDay$textVariant3.nextWeek;
      }
      setSameDaySt(objectSpread2_default()({}, sameDaySt));
    }
  }, []);
  if (!sameDay) {
    return null;
  }
  return /*#__PURE__*/jsx_default()("div", {
    className: external_classnames_default()(SameDay_namespace, className, isMobile ? "".concat(SameDay_namespace, "--mobile") : "".concat(SameDay_namespace, "--desktop"))
  }, void 0, isTextVariant && /*#__PURE__*/jsx_default()(bullets_namespaceObject.Bullets, {
    inverted: inverted
  }, void 0, /*#__PURE__*/jsx_default()(bullets_namespaceObject.BulletsItem, {
    title: "",
    description: sameDaySt.text,
    className: external_classnames_default()("".concat(SameDay_namespace, "__same-day-bullet")),
    type: "body",
    size: isMobile ? 'l' : 'm',
    thumb: (thumb === null || thumb === void 0 ? void 0 : thumb.name) && /*#__PURE__*/jsx_default()(src_Icon, {
      name: thumb.name,
      options: thumb.options || {},
      inverted: inverted
    })
  })));
};

/**
 * PropTypes
 */

SameDay.defaultProps = {
  className: '',
  isMobile: false,
  sameDay: null,
  thumb: null,
  inverted: false
};

/**
 * Export SameDay
 */

/* harmony default export */ const src_SameDay = (SameDay);
;// external "core-js/modules/es.number.constructor.js"
const es_number_constructor_js_namespaceObject = require("core-js/modules/es.number.constructor.js");
;// external "core-js/modules/es.number.is-integer.js"
const es_number_is_integer_js_namespaceObject = require("core-js/modules/es.number.is-integer.js");
;// external "core-js/modules/es.number.is-nan.js"
const es_number_is_nan_js_namespaceObject = require("core-js/modules/es.number.is-nan.js");
;// external "@andes/icons/DispatchTime20"
const DispatchTime20_namespaceObject = require("@andes/icons/DispatchTime20");
var DispatchTime20_default = /*#__PURE__*/__webpack_require__.n(DispatchTime20_namespaceObject);
;// external "@andes/common"
const common_namespaceObject = require("@andes/common");
;// external "@andes/context"
const context_namespaceObject = require("@andes/context");
;// external "core-js/modules/es.parse-int.js"
const es_parse_int_js_namespaceObject = require("core-js/modules/es.parse-int.js");
;// ./components/molecules/countdown/src/hooks.js






var calcSeconds = function calcSeconds(startDate, endDate) {
  var startDateTime = getDateUTC(startDate).getTime();
  var todayTime = getDateUTC().getTime();
  if (!Number.isNaN(startDateTime) && todayTime < startDateTime) {
    return 0;
  }
  var endDateTime = getDateUTC(endDate).getTime();
  return (endDateTime - todayTime) / 1000;
};
var secondsToTime = function secondsToTime(timestamp) {
  var result = timestamp / 60 / 60 / 24;
  var days = parseInt(result, 10);
  result = (result - days) * 24;
  var hours = parseInt(result, 10);
  result = (result - hours) * 60;
  var minutes = parseInt(result, 10);
  result = (result - minutes) * 60;
  var seconds = parseInt(result, 10);
  return {
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds,
    secondsLeft: parseInt(timestamp, 10)
  };
};
function useCountdown(startDate, endDate) {
  var defaultHidden = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var _useState = (0,external_react_namespaceObject.useState)({
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    }),
    _useState2 = slicedToArray_default()(_useState, 2),
    timer = _useState2[0],
    setTimer = _useState2[1];
  var _useState3 = (0,external_react_namespaceObject.useState)(defaultHidden),
    _useState4 = slicedToArray_default()(_useState3, 2),
    hidden = _useState4[0],
    setHidden = _useState4[1];
  var _useState5 = (0,external_react_namespaceObject.useState)(false),
    _useState6 = slicedToArray_default()(_useState5, 2),
    init = _useState6[0],
    setInit = _useState6[1];
  var calcSecondsMemo = (0,external_react_namespaceObject.useCallback)(function () {
    return calcSeconds(startDate, endDate);
  }, [startDate, endDate]);
  (0,external_react_namespaceObject.useEffect)(function () {
    var timestamp = calcSecondsMemo();
    setHidden(timestamp <= 0);
    var interval = setInterval(function () {
      if (timestamp <= 0) {
        setHidden(true);
        clearInterval(interval);
      }
      setTimer(secondsToTime(timestamp));
      setInit(true);
      timestamp -= 1;
    }, 1000);
    return function () {
      return clearInterval(interval);
    };
  }, [calcSecondsMemo]);
  return objectSpread2_default()(objectSpread2_default()({}, timer), {}, {
    hidden: hidden,
    init: init
  });
}
;// ./components/molecules/countdown/src/utils/formatTime.js




var addZero = function addZero(num) {
  return !Number.isNaN(num) && num >= 0 && num < 10 ? "0".concat(Number(num)) : num;
};
var formatDate = function formatDate(time) {
  var date = new Date(time);
  if (Number.isNaN(date.getUTCDate())) {
    return '';
  }
  var year = "".concat(date.getFullYear());
  var month = "".concat(addZero(date.getMonth() + 1));
  var day = "".concat(addZero(date.getDate()));
  var hours = "".concat(addZero(date.getHours()));
  var minutes = "".concat(addZero(date.getMinutes()));
  var seconds = "".concat(addZero(date.getSeconds()));
  return "".concat(month, "/").concat(day, "/").concat(year, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
};
;// external "core-js/modules/es.object.keys.js"
const es_object_keys_js_namespaceObject = require("core-js/modules/es.object.keys.js");
;// ./components/molecules/countdown/src/constants/timeUnits.js
var TIME_UNIT_SYMBOLS = {
  days: 'd',
  hours: 'hs',
  minutes: 'min',
  seconds: 's'
};
var TIME_UNIT_NAMES = {
  seconds: {
    singular: 'segundo',
    plural: 'segundos'
  },
  minutes: {
    singular: 'minuto',
    plural: 'minutos'
  },
  hours: {
    singular: 'hora',
    plural: 'horas'
  },
  days: {
    singular: 'día',
    plural: 'días'
  }
};
;// ./components/molecules/countdown/src/translations/es-AR.json
const es_AR_namespaceObject = /*#__PURE__*/JSON.parse('{"module":"@pog-ui-landings-library/countdown","locale":"es-AR","translations":{"pog-ui-countdown\\u0004d":[null,"d"],"pog-ui-countdown\\u0004hs":[null,"hs"],"pog-ui-countdown\\u0004min":[null,"min"],"pog-ui-countdown\\u0004s":[null,"s"],"pog-ui-countdown\\u0004{0} día":["{0} días","{0} día","{0} días"],"pog-ui-countdown\\u0004{0} hora":["{0} horas","{0} hora","{0} horas"],"pog-ui-countdown\\u0004{0} minuto":["{0} minutos","{0} minuto","{0} minutos"],"pog-ui-countdown\\u0004{0} segundo":["{0} segundos","{0} segundo","{0} segundos"]}}');
var translations_es_AR_namespaceObject = /*#__PURE__*/__webpack_require__.t(es_AR_namespaceObject, 2);
;// ./components/molecules/countdown/src/translations/pt-BR.json
const pt_BR_namespaceObject = /*#__PURE__*/JSON.parse('{"module":"@pog-ui-landings-library/countdown","locale":"pt-BR","translations":{"pog-ui-countdown\\u0004d":[null,"d"],"pog-ui-countdown\\u0004hs":[null,"h"],"pog-ui-countdown\\u0004min":[null,"min"],"pog-ui-countdown\\u0004s":[null,"s"],"pog-ui-countdown\\u0004{0} día":["{0} dias","{0} dia","{0} dias"],"pog-ui-countdown\\u0004{0} hora":["{0} horas","{0} hora","{0} horas"],"pog-ui-countdown\\u0004{0} minuto":["{0} minutos","{0} minuto","{0} minutos"],"pog-ui-countdown\\u0004{0} segundo":["{0} segundos","{0} segundo","{0} segundos"]}}');
var translations_pt_BR_namespaceObject = /*#__PURE__*/__webpack_require__.t(pt_BR_namespaceObject, 2);
;// ./components/molecules/countdown/src/translations/index.js




var I18N_CONTEXT = 'pog-ui-countdown';
;// ./components/molecules/countdown/src/utils/getAccesibleCountdown.js






var DEFAULT_ALERT_SECONDS_DELAY = 15 * 60; // 15 minutes

var getTimeUnitText = function getTimeUnitText(i18n, unit, value) {
  if (!i18n || !unit || !Object.keys(TIME_UNIT_NAMES).includes(unit) || value <= 0) {
    return '';
  }
  var unitTexts = TIME_UNIT_NAMES[unit];
  return " ".concat(i18n.npgettext(I18N_CONTEXT, "{0} ".concat(unitTexts.singular), "{0} ".concat(unitTexts.plural), Number(value), [value]));
};
var getAccesibleCountdown = function getAccesibleCountdown(i18n, label, _ref) {
  var _ref$days = _ref.days,
    days = _ref$days === void 0 ? 0 : _ref$days,
    _ref$hours = _ref.hours,
    hours = _ref$hours === void 0 ? 0 : _ref$hours,
    _ref$minutes = _ref.minutes,
    minutes = _ref$minutes === void 0 ? 0 : _ref$minutes,
    _ref$seconds = _ref.seconds,
    seconds = _ref$seconds === void 0 ? 0 : _ref$seconds;
  if (!i18n) {
    return '';
  }
  var accessibleTime = "".concat(label);
  accessibleTime += getTimeUnitText(i18n, 'days', days);
  accessibleTime += getTimeUnitText(i18n, 'hours', hours);
  accessibleTime += getTimeUnitText(i18n, 'minutes', minutes);
  accessibleTime += getTimeUnitText(i18n, 'seconds', seconds);
  return accessibleTime;
};
;// ./components/molecules/countdown/src/utils/index.js


;// ./components/molecules/countdown/src/Countdown.js




var _DispatchTime, _DispatchTime2;





/**
 * Component dependencies
 */












var Countdown_namespace = 'pog-ui-countdown';

/**
 * Component Countdown
 */
var Countdown = function Countdown(_ref) {
  var className = _ref.className,
    isMobile = _ref.isMobile,
    startDate = _ref.startDate,
    endDate = _ref.endDate,
    text = _ref.text,
    textLabel = _ref.textLabel,
    alertDelay = _ref.alertDelay,
    debug = _ref.debug;
  var i18n = (0,context_namespaceObject.getPatchedI18n)(context_namespaceObject.AndesContext, context_namespaceObject.I18nContext, translations_es_AR_namespaceObject, translations_pt_BR_namespaceObject);
  var timer = useCountdown(startDate, endDate, true);
  var days = timer.days,
    hours = timer.hours,
    minutes = timer.minutes,
    seconds = timer.seconds,
    secondsLeft = timer.secondsLeft,
    hidden = timer.hidden,
    init = timer.init;
  var isValidTime = !Number.isNaN(secondsLeft);
  var alertDelayInMinutes = Number(alertDelay);
  var alertTimeInSeconds = Number.isInteger(alertDelayInMinutes) && alertDelayInMinutes > 0 ? alertDelayInMinutes * 60 : DEFAULT_ALERT_SECONDS_DELAY;
  var _useState = (0,external_react_namespaceObject.useState)({
      tick: true,
      start: false,
      last: ''
    }),
    _useState2 = slicedToArray_default()(_useState, 2),
    a11yUpdateTick = _useState2[0],
    setA11yUpdateTick = _useState2[1];
  var accessibleTime = (0,external_react_namespaceObject.useMemo)(function () {
    return a11yUpdateTick.tick || !a11yUpdateTick.start ? getAccesibleCountdown(i18n, textLabel || text, timer) : a11yUpdateTick.last;
  }, [a11yUpdateTick, init]);
  (0,external_react_namespaceObject.useEffect)(function () {
    setA11yUpdateTick({
      tick: secondsLeft % alertTimeInSeconds === 0,
      start: a11yUpdateTick.last !== '',
      last: accessibleTime
    });
  }, [secondsLeft]);
  var unitTypographyProps = {
    className: "".concat(Countdown_namespace, "__unit"),
    type: 'body',
    size: 'xs',
    color: 'inverted',
    component: 'span'
  };
  var valueTypographyProps = objectSpread2_default()(objectSpread2_default()({}, unitTypographyProps), {}, {
    className: "".concat(Countdown_namespace, "__count"),
    size: isMobile ? 'xl' : 'l'
  });
  if (hidden || !isValidTime) {
    return null;
  }
  return /*#__PURE__*/jsx_default()("div", {
    className: external_classnames_default()(Countdown_namespace, className, "".concat(Countdown_namespace, "--").concat(isMobile ? 'mobile' : 'desktop'), defineProperty_default()({}, "".concat(Countdown_namespace, "--hidden"), hidden && false))
  }, void 0, /*#__PURE__*/jsx_default()(common_namespaceObject.VisuallyHidden, {
    component: "div"
  }, void 0, /*#__PURE__*/jsx_default()("p", {
    id: "alert",
    role: "alert",
    "aria-live": "assertive"
  }, void 0, accessibleTime), debug && /*#__PURE__*/jsx_default()("span", {
    "aria-hidden": "true",
    "data-testid": "countdown"
  }, void 0, timer.days, " d ", timer.hours, " h ", timer.minutes, " m ", timer.seconds, " s")), /*#__PURE__*/jsx_default()("div", {
    className: "".concat(Countdown_namespace, "__container"),
    "aria-hidden": "true"
  }, void 0, /*#__PURE__*/jsx_default()("div", {
    className: "".concat(Countdown_namespace, "__message-wrapper")
  }, void 0, /*#__PURE__*/jsx_default()("div", {
    className: "".concat(Countdown_namespace, "__icon")
  }, void 0, _DispatchTime || (_DispatchTime = _DispatchTime2 || (_DispatchTime2 = /*#__PURE__*/jsx_default()((DispatchTime20_default()), {
    color: "#fff"
  })))), /*#__PURE__*/jsx_default()(typography_namespaceObject.Typography, {
    className: "".concat(Countdown_namespace, "__message"),
    type: "body",
    size: isMobile ? 'm' : 's',
    color: "inverted",
    component: "p",
    "data-testid": "text"
  }, void 0, text)), /*#__PURE__*/jsx_default()("div", {
    className: "".concat(Countdown_namespace, "__timer")
  }, void 0, /*#__PURE__*/jsx_default()("div", {
    className: "".concat(Countdown_namespace, "__time-fraction ").concat(Countdown_namespace, "__days")
  }, void 0, /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(typography_namespaceObject.Typography, objectSpread2_default()(objectSpread2_default()({}, valueTypographyProps), {}, {
    children: days
  })), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(typography_namespaceObject.Typography, objectSpread2_default()(objectSpread2_default()({}, unitTypographyProps), {}, {
    children: i18n.pgettext(I18N_CONTEXT, TIME_UNIT_SYMBOLS.days)
  }))), /*#__PURE__*/jsx_default()("div", {
    className: "".concat(Countdown_namespace, "__time-fraction ").concat(Countdown_namespace, "__hours")
  }, void 0, /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(typography_namespaceObject.Typography, objectSpread2_default()(objectSpread2_default()({}, valueTypographyProps), {}, {
    children: addZero(hours)
  })), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(typography_namespaceObject.Typography, objectSpread2_default()(objectSpread2_default()({}, unitTypographyProps), {}, {
    children: i18n.pgettext(I18N_CONTEXT, TIME_UNIT_SYMBOLS.hours)
  }))), /*#__PURE__*/jsx_default()("div", {
    className: "".concat(Countdown_namespace, "__time-fraction ").concat(Countdown_namespace, "__minutes")
  }, void 0, /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(typography_namespaceObject.Typography, objectSpread2_default()(objectSpread2_default()({}, valueTypographyProps), {}, {
    children: addZero(minutes)
  })), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(typography_namespaceObject.Typography, objectSpread2_default()(objectSpread2_default()({}, unitTypographyProps), {}, {
    children: i18n.pgettext(I18N_CONTEXT, TIME_UNIT_SYMBOLS.minutes)
  }))), /*#__PURE__*/jsx_default()("div", {
    className: "".concat(Countdown_namespace, "__time-fraction ").concat(Countdown_namespace, "__seconds")
  }, void 0, /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(typography_namespaceObject.Typography, objectSpread2_default()(objectSpread2_default()({}, valueTypographyProps), {}, {
    children: addZero(seconds)
  })), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(typography_namespaceObject.Typography, objectSpread2_default()(objectSpread2_default()({}, unitTypographyProps), {}, {
    children: i18n.pgettext(I18N_CONTEXT, TIME_UNIT_SYMBOLS.seconds)
  }))))));
};
Countdown.defaultProps = {
  className: '',
  startDate: new Date(),
  isMobile: false,
  textLabel: '',
  alertDelay: '15',
  debug: false
};
/* harmony default export */ const src_Countdown = (Countdown);
;// external "@babel/runtime/helpers/typeof"
const typeof_namespaceObject = require("@babel/runtime/helpers/typeof");
var typeof_default = /*#__PURE__*/__webpack_require__.n(typeof_namespaceObject);
;// external "core-js/modules/es.array.from.js"
const es_array_from_js_namespaceObject = require("core-js/modules/es.array.from.js");
;// external "core-js/modules/es.string.iterator.js"
const es_string_iterator_js_namespaceObject = require("core-js/modules/es.string.iterator.js");
;// ./components/molecules/moneyAmount/src/constants/currencies.js


var DEFAULT_CURRENCY_SYMBOL = '$';
var DEFAULT_CURRENCY_SYMBOL_TEXT = {
  singular: 'peso',
  plural: 'pesos'
};
var DEFAULT_CENTS_TEXT = {
  singular: 'centavo',
  plural: 'centavos'
};
var CURRENCIES = {
  ARS: {
    id: 'ARS',
    symbol: '$',
    name: 'pesos argentinos'
  },
  BOB: {
    id: 'BOB',
    symbol: 'Bs',
    name: 'bolivianos'
  },
  BRL: {
    id: 'BRL',
    symbol: 'R$',
    name: 'reales'
  },
  CLF: {
    id: 'CLF',
    symbol: 'UF',
    name: 'unidades de fomento'
  },
  CLP: {
    id: 'CLP',
    symbol: '$',
    name: 'pesos chilenos'
  },
  COP: {
    id: 'COP',
    symbol: '$',
    name: 'pesos chilenos'
  },
  CRC: {
    id: 'CRC',
    symbol: '₡',
    name: 'colones'
  },
  CUC: {
    id: 'CUC',
    symbol: 'CUC',
    name: 'cubanos'
  },
  CUP: {
    id: 'CUP',
    symbol: '$',
    name: 'pesos cubanos'
  },
  DOP: {
    id: 'DOP',
    symbol: '$',
    name: 'pesos dominicanos'
  },
  EUR: {
    id: 'EUR',
    symbol: '€',
    name: 'euros'
  },
  GTQ: {
    id: 'GTQ',
    symbol: 'Q',
    name: 'quetzales guatemaltecos'
  },
  HNL: {
    id: 'HNL',
    symbol: 'L',
    name: 'lempiras'
  },
  MXN: {
    id: 'MXN',
    symbol: '$',
    name: 'pesos mexicanos'
  },
  NIO: {
    id: 'NIO',
    symbol: 'C$',
    name: 'córdobas'
  },
  PAB: {
    id: 'PAB',
    symbol: 'B/.',
    name: 'balboas'
  },
  PEN: {
    id: 'PEN',
    symbol: 'S/',
    name: 'soles'
  },
  PYG: {
    id: 'PYG',
    symbol: '₲',
    name: 'guaraníes'
  },
  USD: {
    id: 'USD',
    symbol: 'US$',
    name: 'dólares americanos'
  },
  UYU: {
    id: 'UYU',
    symbol: '$',
    name: 'pesos uruguayos'
  },
  VEF: {
    id: 'VEF',
    symbol: 'Bs.',
    name: 'bolívares'
  },
  VES: {
    id: 'VES',
    symbol: 'Bs.',
    name: 'bolívares'
  }
};
var CURRENCY_SYMBOLS_BY_ID = {
  ARS: '$',
  BOB: 'Bs',
  BRL: 'R$',
  CLF: 'UF',
  CLP: '$',
  COP: '$',
  CRC: '₡',
  CUC: 'CUC',
  CUP: '$',
  DOP: '$',
  EUR: '€',
  GTQ: 'Q',
  HNL: 'L',
  MXN: '$',
  NIO: 'C$',
  PAB: 'B/.',
  PEN: 'S/',
  PYG: '₲',
  USD: 'US$',
  UYU: '$',
  VEF: 'Bs.',
  VES: 'Bs.'
};
var CURRENCY_SYMBOLS = ['$', 'Bs', 'R$', 'UF', '₡', 'CUC', '€', 'Q', 'L', 'C$', 'B/.', 'S/', '₲', 'US$', 'Bs.'];
var DEFAULT_CURRENCY_IDS = ['ARS', 'BOB', 'BRL', 'CLF', 'CLP', 'COP', 'CRC', 'CUC', 'CUP', 'DOP', 'EUR', 'GTQ', 'HNL', 'MXN', 'NIO', 'PAB', 'PEN', 'PYG', 'USD', 'UYU', 'VEF', 'VES'];
var CURRENCY_IDS = Array.from(DEFAULT_CURRENCY_IDS);
var CURRENCY_TEXT_BY_SYMBOL = {
  $: DEFAULT_CURRENCY_SYMBOL_TEXT,
  Bs: {
    singular: 'boliviano',
    plural: 'bolivianos'
  },
  R$: {
    singular: 'real',
    plural: 'reales'
  },
  UF: {
    singular: 'unidad de fomento',
    plural: 'unidades de fomento'
  },
  '₡': {
    singular: 'colón',
    plural: 'colones'
  },
  CUC: DEFAULT_CURRENCY_SYMBOL_TEXT,
  '€': {
    singular: 'euro',
    plural: 'euros'
  },
  Q: {
    singular: 'quetzal guatemalteco',
    plural: 'quetzales guatemaltecos'
  },
  L: {
    singular: 'lempira',
    plural: 'lempiras'
  },
  C$: {
    singular: 'córdoba',
    plural: 'córdobas'
  },
  'B/.': {
    singular: 'balboa',
    plural: 'balboas'
  },
  'S/': {
    singular: 'sol',
    plural: 'soles'
  },
  '₲': {
    singular: 'guaraní',
    plural: 'guaraníes'
  },
  US$: {
    singular: 'dólar',
    plural: 'dólares'
  },
  'Bs.': {
    singular: 'bolívar',
    plural: 'bolívares'
  }
};
var CURRENCY_TEXT_BY_ID = {
  ARS: DEFAULT_CURRENCY_SYMBOL_TEXT,
  BOB: {
    singular: 'boliviano',
    plural: 'bolivianos'
  },
  BRL: {
    singular: 'real',
    plural: 'reales'
  },
  BTC: {
    singular: 'bitcoin',
    plural: 'bitcoins'
  },
  CLF: {
    singular: 'unidad de fomento',
    plural: 'unidades de fomento'
  },
  CLP: DEFAULT_CURRENCY_SYMBOL_TEXT,
  COP: DEFAULT_CURRENCY_SYMBOL_TEXT,
  CRC: {
    singular: 'colón',
    plural: 'colones'
  },
  CUC: DEFAULT_CURRENCY_SYMBOL_TEXT,
  CUP: DEFAULT_CURRENCY_SYMBOL_TEXT,
  DOP: DEFAULT_CURRENCY_SYMBOL_TEXT,
  EUR: {
    singular: 'euro',
    plural: 'euros'
  },
  ETH: {
    singular: 'ethereum',
    plural: 'ethereum'
  },
  GTQ: {
    singular: 'quetzal guatemalteco',
    plural: 'quetzales guatemaltecos'
  },
  HNL: {
    singular: 'lempira',
    plural: 'lempiras'
  },
  MXN: DEFAULT_CURRENCY_SYMBOL_TEXT,
  NIO: {
    singular: 'córdoba',
    plural: 'córdobas'
  },
  PAB: {
    singular: 'balboa',
    plural: 'balboas'
  },
  PEN: {
    singular: 'sol',
    plural: 'soles'
  },
  PYG: {
    singular: 'guaraní',
    plural: 'guaraníes'
  },
  USD: {
    singular: 'dólar',
    plural: 'dólares'
  },
  USDP: {
    singular: 'USDP Stablecoin',
    plural: 'USDP Stablecoins'
  },
  UYU: DEFAULT_CURRENCY_SYMBOL_TEXT,
  VEF: {
    singular: 'bolívar',
    plural: 'bolívares'
  },
  VES: {
    singular: 'bolívar',
    plural: 'bolívares'
  }
};
var CENTS_TEXT_BY_SYMBOL = {
  $: DEFAULT_CENTS_TEXT,
  Bs: DEFAULT_CENTS_TEXT,
  R$: DEFAULT_CENTS_TEXT,
  UF: DEFAULT_CENTS_TEXT,
  '₡': {
    singular: 'céntimo',
    plural: 'céntimos'
  },
  CUC: DEFAULT_CENTS_TEXT,
  '€': DEFAULT_CENTS_TEXT,
  Q: DEFAULT_CENTS_TEXT,
  L: DEFAULT_CENTS_TEXT,
  C$: DEFAULT_CENTS_TEXT,
  'B/.': {
    singular: 'centésimo',
    plural: 'centésimos'
  },
  'S/': {
    singular: 'céntimo',
    plural: 'céntimos'
  },
  '₲': {
    singular: 'céntimo',
    plural: 'céntimos'
  },
  US$: DEFAULT_CENTS_TEXT,
  'Bs.': DEFAULT_CENTS_TEXT
};
var CENTS_TEXT_BY_ID = {
  ARS: DEFAULT_CENTS_TEXT,
  BOB: DEFAULT_CENTS_TEXT,
  BRL: DEFAULT_CENTS_TEXT,
  CLF: DEFAULT_CENTS_TEXT,
  CLP: DEFAULT_CENTS_TEXT,
  COP: DEFAULT_CENTS_TEXT,
  CRC: {
    singular: 'céntimo',
    plural: 'céntimos'
  },
  CUC: DEFAULT_CENTS_TEXT,
  CUP: DEFAULT_CENTS_TEXT,
  DOP: DEFAULT_CENTS_TEXT,
  EUR: DEFAULT_CENTS_TEXT,
  GTQ: DEFAULT_CENTS_TEXT,
  HNL: DEFAULT_CENTS_TEXT,
  MXN: DEFAULT_CENTS_TEXT,
  NIO: DEFAULT_CENTS_TEXT,
  PAB: {
    singular: 'centésimo',
    plural: 'centésimos'
  },
  PEN: {
    singular: 'céntimo',
    plural: 'céntimos'
  },
  PYG: {
    singular: 'céntimo',
    plural: 'céntimos'
  },
  USD: DEFAULT_CENTS_TEXT,
  UYU: {
    singular: 'centésimo',
    plural: 'centésimos'
  },
  VEF: DEFAULT_CENTS_TEXT,
  VES: DEFAULT_CENTS_TEXT
};
;// external "core-js/modules/es.regexp.exec.js"
const es_regexp_exec_js_namespaceObject = require("core-js/modules/es.regexp.exec.js");
;// external "core-js/modules/es.string.replace.js"
const es_string_replace_js_namespaceObject = require("core-js/modules/es.string.replace.js");
;// external "@andes/badge"
const badge_namespaceObject = require("@andes/badge");
;// ./utils/constants/numberFormatting.js
var DECIMAL_SEPARATOR_COMMA = ',';
var DECIMAL_SEPARATOR_DOT = '.';
var DECIMAL_SEPARATOR_SUPERSCRIPT = '';
var DECIMAL_SEPARATOR_BY_CENTS_TYPE = {
  comma: DECIMAL_SEPARATOR_COMMA,
  dot: DECIMAL_SEPARATOR_DOT,
  superscript: DECIMAL_SEPARATOR_SUPERSCRIPT
};
var THOUSANDS_SEPARATOR_COMMA = ',';
var THOUSANDS_SEPARATOR_DOT = '.';
var THOUSANDS_SEPARATOR_NONE = '';
var THOUSANDS_SEPARATOR_BY_TYPES = {
  comma: THOUSANDS_SEPARATOR_COMMA,
  dot: THOUSANDS_SEPARATOR_DOT,
  none: THOUSANDS_SEPARATOR_NONE
};
;// ./components/molecules/moneyAmount/src/utils/centsFont.js
var centsSize = function centsSize(centsType, typographyType) {
  var size;
  if (typographyType === 'title') {
    size = centsType === 'superscript' ? 'xs' : 'xxl';
  } else {
    size = centsType === 'superscript' ? 'xxs' : 'l';
  }
  return size;
};
;// ./components/molecules/moneyAmount/src/translations/es-AR.json
const src_translations_es_AR_namespaceObject = /*#__PURE__*/JSON.parse('{"module":"@pog-ui-landings-library/money-amount","locale":"es-AR","translations":{"pog-ui-money-amount\\u0004{0} peso":["{0} pesos","{0} peso","{0} pesos"],"pog-ui-money-amount\\u0004{0} boliviano":["{0} bolivianos","{0} boliviano","{0} bolivianos"],"pog-ui-money-amount\\u0004{0} real":["{0} reales","{0} real","{0} reales"],"pog-ui-money-amount\\u0004{0} unidad de fomento":["{0} unidades de fomento","{0} unidad de fomento","{0} unidades de fomento"],"pog-ui-money-amount\\u0004{0} colón":["{0} colones","{0} colón","{0} colones"],"pog-ui-money-amount\\u0004{0} euro":["{0} euros","{0} euro","{0} euros"],"pog-ui-money-amount\\u0004{0} quetzal guatemalteco":["{0} quetzales guatemaltecos","{0} quetzal guatemalteco","{0} quetzales guatemaltecos"],"pog-ui-money-amount\\u0004{0} lempira":["{0} lempiras","{0} lempira","{0} lempiras"],"pog-ui-money-amount\\u0004{0} córdoba":["{0} córdobas","{0} córdoba","{0} córdobas"],"pog-ui-money-amount\\u0004{0} balboa":["{0} balboas","{0} balboa","{0} balboas"],"pog-ui-money-amount\\u0004{0} sol":["{0} soles","{0} sol","{0} soles"],"pog-ui-money-amount\\u0004{0} guaraní":["{0} guaraníes","{0} guaraní","{0} guaraníes"],"pog-ui-money-amount\\u0004{0} dólar":["{0} dólares","{0} dólar","{0} dólares"],"pog-ui-money-amount\\u0004{0} bolívar":["{0} bolívares","{0} bolívar","{0} bolívares"],"pog-ui-money-amount\\u0004 con {0} centavo":[" con {0} centavos"," con {0} centavo"," con {0} centavos"],"pog-ui-money-amount\\u0004 con {0} céntimo":[" con {0} céntimos"," con {0} céntimo"," con {0} céntimos"],"pog-ui-money-amount\\u0004 con {0} centésimo":[" con {0} centésimos"," con {0} centésimo"," con {0} centésimos"]}}');
var moneyAmount_src_translations_es_AR_namespaceObject = /*#__PURE__*/__webpack_require__.t(src_translations_es_AR_namespaceObject, 2);
;// ./components/molecules/moneyAmount/src/translations/pt-BR.json
const src_translations_pt_BR_namespaceObject = /*#__PURE__*/JSON.parse('{"module":"@pog-ui-landings-library/money-amount","locale":"pt-BR","translations":{"pog-ui-money-amount\\u0004{0} peso":["{0} pesos","{0} peso","{0} pesos"],"pog-ui-money-amount\\u0004{0} boliviano":["{0} bolivianos","{0} boliviano","{0} bolivianos"],"pog-ui-money-amount\\u0004{0} real":["{0} reales","{0} real","{0} reais"],"pog-ui-money-amount\\u0004{0} unidad de fomento":["{0} unidades de fomento","{0} unidade de promoção","{0} unidades de promoção"],"pog-ui-money-amount\\u0004{0} colón":["{0} colones","{0} colon","{0} colones"],"pog-ui-money-amount\\u0004{0} euro":["{0} euros","{0} euro","{0} euros"],"pog-ui-money-amount\\u0004{0} quetzal guatemalteco":["{0} quetzales guatemaltecos","{0} quetzal guatemalteco","{0} quetzais guatemaltecos"],"pog-ui-money-amount\\u0004{0} lempira":["{0} lempiras","{0} lempira","{0} lempiras"],"pog-ui-money-amount\\u0004{0} córdoba":["{0} córdobas","{0} córdoba","{0} córdobas"],"pog-ui-money-amount\\u0004{0} balboa":["{0} balboas","{0} balboa","{0} balboas"],"pog-ui-money-amount\\u0004{0} sol":["{0} soles","{0} sol","{0} sóis"],"pog-ui-money-amount\\u0004{0} guaraní":["{0} guaraníes","{0} guarani","{0} guaranis"],"pog-ui-money-amount\\u0004{0} dólar":["{0} dólares","{0} dólar","{0} dólares"],"pog-ui-money-amount\\u0004{0} bolívar":["{0} bolívares","{0} bolívar","{0} bolívares"],"pog-ui-money-amount\\u0004 con {0} centavo":[" e {0} centavos"," e {0} centavo"," e {0} centavos"],"pog-ui-money-amount\\u0004 con {0} céntimo":[" e {0} céntimos"," e {0} cêntimo"," e {0} cêntimos"],"pog-ui-money-amount\\u0004 con {0} centésimo":[" e {0} centésimos"," e {0} centésimo"," e {0} centésimos"]}}');
var moneyAmount_src_translations_pt_BR_namespaceObject = /*#__PURE__*/__webpack_require__.t(src_translations_pt_BR_namespaceObject, 2);
;// ./components/molecules/moneyAmount/src/translations/index.js




var translations_I18N_CONTEXT = 'pog-ui-money-amount';
;// ./components/molecules/moneyAmount/src/utils/getAccesibleAmount.js







var getRelatedText = function getRelatedText(symbol, currencyId, DEFAULT, TEXTS_BY_SYMBOL, TEXTS_BY_ID) {
  if ((!symbol || !CURRENCY_SYMBOLS.includes(symbol)) && (!currencyId || !CURRENCY_IDS.includes(currencyId))) {
    return DEFAULT;
  }
  return TEXTS_BY_SYMBOL[String(symbol)] || TEXTS_BY_ID[String(currencyId)];
};
var getCurrencyText = function getCurrencyText(symbol, currencyId) {
  return getRelatedText(symbol, currencyId, DEFAULT_CURRENCY_SYMBOL_TEXT, CURRENCY_TEXT_BY_SYMBOL, CURRENCY_TEXT_BY_ID);
};
var getCentsText = function getCentsText(symbol, currencyId) {
  return getRelatedText(symbol, currencyId, DEFAULT_CENTS_TEXT, CENTS_TEXT_BY_SYMBOL, CENTS_TEXT_BY_ID);
};
var getAccesibleAmount = function getAccesibleAmount(i18n, prefixLabel, suffixLabel, _ref, discount) {
  var symbol = _ref.symbol,
    currencyId = _ref.currencyId,
    fraction = _ref.fraction,
    cents = _ref.cents;
  if (!i18n || !fraction && fraction !== 0 || !symbol && !currencyId) {
    return '';
  }
  var currencyText = getCurrencyText(symbol, currencyId);
  var centsText = getCentsText(symbol, currencyId);
  var normalizedFraction = String(fraction).replace(/[,.]/g, '');
  var accesibleAmount = '';
  if (prefixLabel) {
    accesibleAmount += "".concat(prefixLabel, " ");
  }
  accesibleAmount += i18n.npgettext(translations_I18N_CONTEXT, "{0} ".concat(currencyText.singular), "{0} ".concat(currencyText.plural), Number(normalizedFraction), [Number(normalizedFraction)]);
  if (cents && Number(cents)) {
    accesibleAmount += i18n.npgettext(translations_I18N_CONTEXT, " con {0} ".concat(centsText.singular), " con {0} ".concat(centsText.plural), Number(cents), [Number(cents)]);
  }
  if (suffixLabel) {
    accesibleAmount += " ".concat(suffixLabel, ". ");
  }
  if (discount) {
    accesibleAmount += " (".concat(discount, ")");
  }
  return accesibleAmount;
};
;// external "core-js/modules/es.array.for-each.js"
const es_array_for_each_js_namespaceObject = require("core-js/modules/es.array.for-each.js");
;// external "core-js/modules/es.array.join.js"
const es_array_join_js_namespaceObject = require("core-js/modules/es.array.join.js");
;// external "core-js/modules/es.array.reverse.js"
const es_array_reverse_js_namespaceObject = require("core-js/modules/es.array.reverse.js");
;// external "core-js/modules/es.object.to-string.js"
const es_object_to_string_js_namespaceObject = require("core-js/modules/es.object.to-string.js");
;// external "core-js/modules/esnext.iterator.constructor.js"
const esnext_iterator_constructor_js_namespaceObject = require("core-js/modules/esnext.iterator.constructor.js");
;// external "core-js/modules/esnext.iterator.for-each.js"
const esnext_iterator_for_each_js_namespaceObject = require("core-js/modules/esnext.iterator.for-each.js");
;// external "core-js/modules/web.dom-collections.for-each.js"
const web_dom_collections_for_each_js_namespaceObject = require("core-js/modules/web.dom-collections.for-each.js");
;// ./components/molecules/moneyAmount/src/utils/thousandsFormat.js









var addThousandSeparator = function addThousandSeparator(fraction, separator) {
  var formattedAsArray = [];
  var reversed = Array.from(String(fraction)).reverse();
  reversed.forEach(function (digit, idx) {
    if (idx > 0 && idx % 3 === 0) {
      formattedAsArray.push(separator);
    }
    formattedAsArray.push(digit);
  });
  return formattedAsArray.reverse().join('');
};
;// ./components/molecules/moneyAmount/src/utils/index.js







var utils_addZero = function addZero(num) {
  return num >= 0 && num < 10 ? "0".concat(num) : num;
};
var getCurrencySymbolById = function getCurrencySymbolById(currencyId) {
  if (!currencyId) {
    return null;
  }
  if (Object.keys(CURRENCIES).includes(currencyId)) {
    return CURRENCIES[currencyId].symbol;
  }
  return CURRENCIES[0].symbol;
};
;// ./components/molecules/moneyAmount/src/MoneyAmount.js




var _excluded = ["className", "isMobile", "amount", "sharedCurrencyId", "prefix", "prefixLabel", "suffix", "suffixLabel", "prefixOptions", "suffixOptions", "size", "previous", "centsType", "thousandsType", "discount", "inverted", "showCurrencyText"];






/**
 * Component dependencies
 */












var MoneyAmount_namespace = 'pog-ui-money-amount';

/**
 * MoneyAmount
 */
var MoneyAmount = function MoneyAmount(_ref) {
  var _AndesLandingsTypogra, _AndesLandingsTypogra2;
  var className = _ref.className,
    isMobile = _ref.isMobile,
    amount = _ref.amount,
    sharedCurrencyId = _ref.sharedCurrencyId,
    oldPrefixProp = _ref.prefix,
    oldPrefixLabelProp = _ref.prefixLabel,
    oldSuffixProp = _ref.suffix,
    oldSuffixLabelProp = _ref.suffixLabel,
    prefixOptions = _ref.prefixOptions,
    suffixOptions = _ref.suffixOptions,
    size = _ref.size,
    previous = _ref.previous,
    centsType = _ref.centsType,
    thousandsType = _ref.thousandsType,
    discount = _ref.discount,
    inverted = _ref.inverted,
    showCurrencyText = _ref.showCurrencyText,
    otherProps = objectWithoutProperties_default()(_ref, _excluded);
  var _ref2 = amount || {},
    fraction = _ref2.fraction,
    _ref2$cents = _ref2.cents,
    cents = _ref2$cents === void 0 ? '' : _ref2$cents;
  if (!fraction && fraction !== 0) {
    return null;
  }
  var currencyId = sharedCurrencyId || (amount === null || amount === void 0 ? void 0 : amount.currencyId) || CURRENCY_IDS[0];
  var symbol = amount !== null && amount !== void 0 && amount.symbol && !sharedCurrencyId ? amount.symbol : getCurrencySymbolById(currencyId);
  var prefixConfig = objectSpread2_default()({}, prefixOptions);
  var suffixConfig = objectSpread2_default()({}, suffixOptions);
  if (!prefixOptions && (oldPrefixProp || oldPrefixLabelProp)) {
    prefixConfig.text = oldPrefixProp;
    prefixConfig.ariaLabel = oldPrefixLabelProp;
  }
  if (!suffixOptions && (oldSuffixProp || oldSuffixLabelProp)) {
    suffixConfig.text = oldSuffixProp;
    suffixConfig.ariaLabel = oldSuffixLabelProp;
  }
  var sanitizedFraction = "".concat(fraction).replace(/[.,]/, '');
  var textColor = inverted ? 'inverted' : 'primary';
  var isRegularPrice = size === 'regular';
  var typographySize = isRegularPrice ? 'l' : 'xxl';
  var typographyType = isRegularPrice ? 'body' : 'title';
  var ignoreSuffix = !isRegularPrice && !!prefixConfig.text;
  var i18n = (0,context_namespaceObject.getPatchedI18n)(context_namespaceObject.AndesContext, moneyAmount_src_translations_es_AR_namespaceObject, moneyAmount_src_translations_pt_BR_namespaceObject);
  var amountClassNames = external_classnames_default()(MoneyAmount_namespace, className, defineProperty_default()(defineProperty_default()(defineProperty_default()(defineProperty_default()({}, "".concat(MoneyAmount_namespace, "--previous"), previous), "".concat(MoneyAmount_namespace, "--previous_inverted"), inverted && previous), "".concat(MoneyAmount_namespace, "--cents-").concat(centsType), centsType), "".concat(MoneyAmount_namespace, "--").concat(isMobile ? 'mobile' : 'desktop'), true));
  var decimalSeparator = DECIMAL_SEPARATOR_BY_CENTS_TYPE[centsType];
  var thousandsSeparator = THOUSANDS_SEPARATOR_BY_TYPES[thousandsType];
  var centsAsNumber = null;
  var fractionAsNumber = null;
  if ((!!cents || cents === 0) && !Number.isNaN(Number(cents)) && Number.isInteger(Number(cents))) {
    centsAsNumber = Number(cents) >= 0 ? Number(cents) : 0;
  }
  if ((!!sanitizedFraction || sanitizedFraction === 0) && !Number.isNaN(sanitizedFraction) && Number.isInteger(Number(sanitizedFraction))) {
    fractionAsNumber = Number(sanitizedFraction);
  }

  // When strings sent, show them (placeholders usage)
  var hasStringCents = centsAsNumber === null && !!cents;
  var hasStringFraction = fractionAsNumber === null && !!fraction;
  var hasStringDefinitions = hasStringFraction || hasStringCents;
  var getCents = function getCents() {
    if (!cents && cents !== 0 || !hasStringCents && Number(cents) < 0) {
      return null;
    }
    return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
      children: [decimalSeparator !== DECIMAL_SEPARATOR_SUPERSCRIPT && (_AndesLandingsTypogra || (_AndesLandingsTypogra = _AndesLandingsTypogra2 || (_AndesLandingsTypogra2 = /*#__PURE__*/jsx_default()(typography_namespaceObject.Typography, {
        className: "".concat(MoneyAmount_namespace, "__decimal-separator"),
        type: typographyType,
        size: typographySize,
        color: textColor,
        "aria-hidden": true
      }, void 0, decimalSeparator)))), decimalSeparator === DECIMAL_SEPARATOR_SUPERSCRIPT && /*#__PURE__*/jsx_default()(common_namespaceObject.VisuallyHidden, {
        "aria-hidden": true
      }, void 0, thousandsSeparator === THOUSANDS_SEPARATOR_COMMA ? DECIMAL_SEPARATOR_DOT : DECIMAL_SEPARATOR_COMMA), /*#__PURE__*/jsx_default()(typography_namespaceObject.Typography, {
        className: "".concat(MoneyAmount_namespace, "__cents"),
        type: typographyType,
        size: centsSize(centsType, typographyType),
        color: textColor,
        "aria-hidden": true
      }, void 0, hasStringCents && cents, !hasStringCents && String(centsType === 'superscript' ? utils_addZero(centsAsNumber) : centsAsNumber).substring(0, 2))]
    });
  };
  var getFormattedFraction = function getFormattedFraction(value) {
    if (!thousandsSeparator || thousandsSeparator === THOUSANDS_SEPARATOR_NONE || thousandsSeparator === decimalSeparator) {
      return Number(value);
    }
    return addThousandSeparator(value, thousandsSeparator);
  };
  var getAccesibleText = function getAccesibleText() {
    return getAccesibleAmount(i18n, prefixConfig.ariaLabel || prefixConfig.text, ignoreSuffix ? '' : suffixConfig.ariaLabel || suffixConfig.text, objectSpread2_default()(objectSpread2_default()({}, amount), {}, {
      fraction: fractionAsNumber,
      cents: centsAsNumber,
      currencyId: currencyId,
      symbol: symbol
    }), discount);
  };
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("div", objectSpread2_default()(objectSpread2_default()({}, otherProps), {}, {
    className: amountClassNames,
    children: [!hasStringDefinitions && /*#__PURE__*/jsx_default()(common_namespaceObject.VisuallyHidden, {}, void 0, getAccesibleText()), prefixConfig.text && /*#__PURE__*/jsx_default()(typography_namespaceObject.Typography, {
      type: typographyType,
      size: typographySize,
      color: textColor,
      className: "".concat(MoneyAmount_namespace, "__prefix"),
      "aria-hidden": true
    }, void 0, "".concat(prefixConfig.text)), /*#__PURE__*/jsx_default()(typography_namespaceObject.Typography, {
      type: typographyType,
      size: typographySize,
      component: "span",
      color: textColor,
      className: "".concat(MoneyAmount_namespace, "__currency-symbol"),
      "aria-hidden": true
    }, void 0, showCurrencyText ? currencyId : symbol || CURRENCY_SYMBOLS_BY_ID[String(currencyId)] || DEFAULT_CURRENCY_SYMBOL), /*#__PURE__*/jsx_default()(typography_namespaceObject.Typography, {
      type: typographyType,
      size: typographySize,
      component: "span",
      color: textColor,
      className: "".concat(MoneyAmount_namespace, "__fraction"),
      "aria-hidden": true
    }, void 0, hasStringFraction && fraction, !hasStringFraction && getFormattedFraction(String(sanitizedFraction))), getCents(), suffixConfig.text && !ignoreSuffix && /*#__PURE__*/jsx_default()(typography_namespaceObject.Typography, {
      type: "body",
      size: typographySize,
      color: textColor,
      className: "".concat(MoneyAmount_namespace, "__suffix"),
      "aria-hidden": true
    }, void 0, "".concat(suffixConfig.text)), discount && !isRegularPrice && /*#__PURE__*/jsx_default()(badge_namespaceObject.Pill, {
      className: "".concat(MoneyAmount_namespace, "__discount"),
      color: "green",
      size: "large",
      hierarchy: "loud",
      "aria-hidden": true
    }, void 0, discount)]
  }));
};
MoneyAmount.defaultProps = {
  className: '',
  isMobile: false,
  prefix: '',
  prefixLabel: '',
  suffix: '',
  suffixLabel: '',
  size: 'main',
  previous: false,
  centsType: 'superscript',
  thousandsType: 'none',
  discount: '',
  inverted: false,
  showCurrencyText: false
};

/**
 * Export component
 */
/* harmony default export */ const src_MoneyAmount = (MoneyAmount);
;// ./utils/constants/htmlTags.js
var ALLOWED_TAGS = {
  // WARN: Andes Landings will not support 'b', 'i', 'em' tags.
  STYLED_LABEL: ['p', 'ul', 'li', 'ol', 'a', 'strong', 'b', 'i', 'em', 'br'],
  FAQS_LIST_ITEM: ['a', 'strong', 'b', 'i', 'em'],
  VOLANTA: ['p'],
  MODAL_CONTENT: ['p', 'a', 'strong', 'em', 'ul', 'ol', 'li'],
  // FIXME: Future versions may support also a and em.
  DESCRIPTION: ['p', 'strong'],
  GENERAL_TEXT: ['p', 'strong'],
  PREFOOTER: ['p'],
  SVG: ['svg', 'path', 'rect', 'g', 'defs', 'clipPath', 'circle', 'mask', 'filter', 'feFlood', 'feColorMatrix', 'feOffset', 'feBlend']
};
var ALLOWED_ATTRIBUTES = {
  LINK_ATTRIBUTES: ['href', 'name', 'target', 'class', 'data-*']
};
var DEFAULT_SANITIZATION_CONFIG = {
  allowedTags: ALLOWED_TAGS.STYLED_LABEL,
  allowedAttributes: {
    a: ALLOWED_ATTRIBUTES.LINK_ATTRIBUTES
  }
};

// AL Title's Volanta
var AL_VOLANTA_SANITIZATION_CONFIG = {
  allowedTags: ALLOWED_TAGS.VOLANTA
};

// AL Title's Description
var AL_DESCRIPTION_SANITIZATION_CONFIG = {
  allowedTags: ALLOWED_TAGS.DESCRIPTION,
  allowedAttributes: {
    a: ALLOWED_ATTRIBUTES.LINK_ATTRIBUTES
  }
};

// Generic text
var AL_GENERIC_TEXT_SANITIZATION_CONFIG = {
  allowedTags: ALLOWED_TAGS.GENERAL_TEXT
};

/**
 * General Sanitization rules
 * These rules cover sanitization for elements across several components (like AL Title sub-elements)
 *
 * For override these rules or specific elements rules, define them inside the component folder constants.
 */

var GENERAL_SANITIZATION_RULES = {
  AL_DESCRIPTION_SANITIZATION_CONFIG: AL_DESCRIPTION_SANITIZATION_CONFIG,
  AL_GENERIC_TEXT_SANITIZATION_CONFIG: AL_GENERIC_TEXT_SANITIZATION_CONFIG,
  AL_VOLANTA_SANITIZATION_CONFIG: AL_VOLANTA_SANITIZATION_CONFIG
};
;// external "sanitize-html"
const external_sanitize_html_namespaceObject = require("sanitize-html");
var external_sanitize_html_default = /*#__PURE__*/__webpack_require__.n(external_sanitize_html_namespaceObject);
;// ./utils/src/sanitizeHTML.js


var sanitize = function sanitize(html) {
  var sanitizeConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var clean = Object.keys(sanitizeConfig).length ? external_sanitize_html_default()(html, sanitizeConfig) : external_sanitize_html_default()(html);
  return clean;
};
/* harmony default export */ const sanitizeHTML = (sanitize);
;// ./utils/src/typographyHelpers.js




var getTypographyPropsForHtmlContent = function getTypographyPropsForHtmlContent(content) {
  var sanitize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var sanitizeConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_SANITIZATION_CONFIG;
  if (!content) {
    return null;
  }
  var children = sanitize ? sanitizeHTML(content, sanitizeConfig) : content;
  return {
    children: children,
    contentHtml: true
  };
};
var getTypographyPropsForALGenericText = function getTypographyPropsForALGenericText(content, customSanitizationConfig) {
  return getTypographyPropsForHtmlContent(content, true, customSanitizationConfig || GENERAL_SANITIZATION_RULES.AL_GENERIC_TEXT_SANITIZATION_CONFIG);
};
var hasParagraphTag = function hasParagraphTag(content) {
  return typeof content === 'string' && ((content === null || content === void 0 ? void 0 : content.includes('<p ')) || (content === null || content === void 0 ? void 0 : content.includes('<p>')));
};
;// ./components/molecules/moneyAmount/src/MoneyAmountBox.js





var MoneyAmountBox_excluded = ["className", "isMobile", "currentAmount", "previousAmount", "alternativeAmount", "discount", "description", "currencyId", "centsType", "thousandsType", "showCurrencyText", "inverted"];





/**
 * Component dependencies
 */








var MoneyAmountBox_namespace = 'pog-ui-money-amount-box';
var MoneyAmountBox = function MoneyAmountBox(_ref) {
  var _currentAmount$amount, _currentAmount$amount2, _alternativeAmount$am, _alternativeAmount$am2, _alternativeAmount$am3, _previousAmount$amoun, _previousAmount$amoun2, _previousAmount$amoun3;
  var className = _ref.className,
    isMobile = _ref.isMobile,
    currentAmount = _ref.currentAmount,
    previousAmount = _ref.previousAmount,
    alternativeAmount = _ref.alternativeAmount,
    discount = _ref.discount,
    description = _ref.description,
    currencyId = _ref.currencyId,
    centsType = _ref.centsType,
    thousandsType = _ref.thousandsType,
    showCurrencyText = _ref.showCurrencyText,
    inverted = _ref.inverted,
    props = objectWithoutProperties_default()(_ref, MoneyAmountBox_excluded);
  if (!(currentAmount !== null && currentAmount !== void 0 && (_currentAmount$amount = currentAmount.amount) !== null && _currentAmount$amount !== void 0 && _currentAmount$amount.fraction)) {
    return null;
  }
  var sharedCurrencyId = currencyId || (currentAmount === null || currentAmount === void 0 || (_currentAmount$amount2 = currentAmount.amount) === null || _currentAmount$amount2 === void 0 ? void 0 : _currentAmount$amount2.currencyId) || undefined;
  var textColor = inverted ? 'inverted' : 'primary';
  var amountBoxClassnames = external_classnames_default()(MoneyAmountBox_namespace, className, defineProperty_default()({}, "".concat(MoneyAmountBox_namespace, "--").concat(isMobile ? 'mobile' : 'desktop'), true));

  // Allow string for placeholder-alike strings
  var alternativeAmountFractionType = typeof_default()(alternativeAmount === null || alternativeAmount === void 0 || (_alternativeAmount$am = alternativeAmount.amount) === null || _alternativeAmount$am === void 0 ? void 0 : _alternativeAmount$am.fraction);
  var showAlternativeAmount = alternativeAmountFractionType === 'string' && (alternativeAmount === null || alternativeAmount === void 0 || (_alternativeAmount$am2 = alternativeAmount.amount) === null || _alternativeAmount$am2 === void 0 || (_alternativeAmount$am2 = _alternativeAmount$am2.fraction) === null || _alternativeAmount$am2 === void 0 ? void 0 : _alternativeAmount$am2.includes('{')) || (alternativeAmount === null || alternativeAmount === void 0 || (_alternativeAmount$am3 = alternativeAmount.amount) === null || _alternativeAmount$am3 === void 0 ? void 0 : _alternativeAmount$am3.fraction) >= 0;
  var previousAmountFractionType = typeof_default()(previousAmount === null || previousAmount === void 0 || (_previousAmount$amoun = previousAmount.amount) === null || _previousAmount$amoun === void 0 ? void 0 : _previousAmount$amoun.fraction);
  var showPreviousAmount = previousAmountFractionType === 'string' && (previousAmount === null || previousAmount === void 0 || (_previousAmount$amoun2 = previousAmount.amount) === null || _previousAmount$amoun2 === void 0 || (_previousAmount$amoun2 = _previousAmount$amoun2.fraction) === null || _previousAmount$amoun2 === void 0 ? void 0 : _previousAmount$amoun2.includes('{')) || (previousAmount === null || previousAmount === void 0 || (_previousAmount$amoun3 = previousAmount.amount) === null || _previousAmount$amoun3 === void 0 ? void 0 : _previousAmount$amoun3.fraction) >= 0;
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("div", objectSpread2_default()(objectSpread2_default()({
    className: amountBoxClassnames
  }, props), {}, {
    children: [/*#__PURE__*/jsx_default()("div", {
      className: "".concat(MoneyAmountBox_namespace, "__amounts-container")
    }, void 0, /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(src_MoneyAmount, objectSpread2_default()(objectSpread2_default()({}, currentAmount), {}, {
      className: external_classnames_default()("".concat(MoneyAmountBox_namespace, "__current-amount"), currentAmount.className),
      sharedCurrencyId: sharedCurrencyId,
      size: "main",
      previous: false,
      showCurrencyText: showCurrencyText,
      centsType: centsType,
      thousandsType: thousandsType,
      discount: discount,
      inverted: inverted,
      isMobile: isMobile
    })), showPreviousAmount && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(src_MoneyAmount, objectSpread2_default()(objectSpread2_default()({}, previousAmount), {}, {
      className: external_classnames_default()("".concat(MoneyAmountBox_namespace, "__previous-amount"), previousAmount.className),
      sharedCurrencyId: sharedCurrencyId,
      size: "regular",
      previous: true,
      showCurrencyText: showCurrencyText,
      centsType: centsType,
      thousandsType: thousandsType,
      discount: "",
      inverted: inverted,
      isMobile: isMobile
    })), showAlternativeAmount && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(src_MoneyAmount, objectSpread2_default()(objectSpread2_default()({}, alternativeAmount), {}, {
      className: external_classnames_default()("".concat(MoneyAmountBox_namespace, "__alternative-amount"), alternativeAmount.className),
      sharedCurrencyId: sharedCurrencyId,
      size: "regular",
      previous: false,
      showCurrencyText: showCurrencyText,
      centsType: centsType,
      thousandsType: thousandsType,
      discount: "",
      inverted: inverted,
      isMobile: isMobile
    }))), description && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(typography_namespaceObject.Typography, objectSpread2_default()(objectSpread2_default()({
      className: "".concat(MoneyAmountBox_namespace, "__description"),
      type: "body",
      size: "m",
      color: textColor,
      component: hasParagraphTag(description) ? 'div' : 'p'
    }, getTypographyPropsForALGenericText(description)), {}, {
      children: description
    }))]
  }));
};
MoneyAmountBox.defaultProps = {
  className: '',
  isMobile: false,
  previousAmount: null,
  alternativeAmount: null,
  discount: '',
  description: '',
  centsType: 'superscript',
  thousandsType: 'none',
  showCurrencyText: false,
  inverted: false
};

/**
 * Export component
 */
/* harmony default export */ const src_MoneyAmountBox = (MoneyAmountBox);
;// external "core-js/modules/es.array.map.js"
const es_array_map_js_namespaceObject = require("core-js/modules/es.array.map.js");
;// external "core-js/modules/esnext.iterator.map.js"
const esnext_iterator_map_js_namespaceObject = require("core-js/modules/esnext.iterator.map.js");
;// ./utils/src/marginHelpers.js

var SPACING_MARGIN_MODE = {
  ALL: 'all',
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical'
};
var setVerticalMargins = function setVerticalMargins(margins) {
  var marginTop = margins === null || margins === void 0 ? void 0 : margins.top;
  var marginBottom = margins === null || margins === void 0 ? void 0 : margins.bottom;
  return {
    marginTop: marginTop,
    marginBottom: marginBottom
  };
};
var setHorizontalMargins = function setHorizontalMargins(margins) {
  var marginLeft = margins === null || margins === void 0 ? void 0 : margins.left;
  var marginRight = margins === null || margins === void 0 ? void 0 : margins.right;
  return {
    marginLeft: marginLeft,
    marginRight: marginRight
  };
};
var setMargins = function setMargins(margins, isMobile) {
  var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : SPACING_MARGIN_MODE.VERTICAL;
  var _ref = margins || {},
    desktop = _ref.desktop,
    mobile = _ref.mobile;
  var deviceMargins = isMobile ? mobile : desktop;
  var horizontalMargins = mode === SPACING_MARGIN_MODE.VERTICAL ? {} : setHorizontalMargins(deviceMargins);
  var verticalMargins = mode === SPACING_MARGIN_MODE.HORIZONTAL ? {} : setVerticalMargins(deviceMargins);
  return objectSpread2_default()(objectSpread2_default()({}, verticalMargins), horizontalMargins);
};
;// ./components/molecules/spacer/src/Spacer.js




/**
 * Component dependencies
 */





var Spacer_namespace = 'pog-ui-spacer';

/**
 * Component
 */

var Spacer = function Spacer(_ref) {
  var children = _ref.children,
    margins = _ref.margins,
    isMobile = _ref.isMobile;
  // Returns null if given child is not a valid React component
  if (! /*#__PURE__*/(0,external_react_namespaceObject.isValidElement)(children)) {
    return null;
  }
  var options = margins ? setMargins(margins, isMobile, SPACING_MARGIN_MODE.VERTICAL) : null;
  var styles = objectSpread2_default()({}, options);
  if (!margins || !styles.marginTop && !styles.marginBottom) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(jsx_runtime_namespaceObject.Fragment, {
      children: children
    });
  }
  return margins && /*#__PURE__*/jsx_default()("div", {
    className: external_classnames_default()(Spacer_namespace),
    style: styles
  }, void 0, external_react_namespaceObject.Children === null || external_react_namespaceObject.Children === void 0 ? void 0 : external_react_namespaceObject.Children.map(children, function (child) {
    return /*#__PURE__*/(0,external_react_namespaceObject.cloneElement)(child, objectSpread2_default()({}, child.props));
  }));
};
Spacer.defaultProps = {
  margins: null,
  isMobile: false
};
/* harmony default export */ const src_Spacer = (Spacer);
;// external "@babel/runtime/helpers/regeneratorRuntime"
const regeneratorRuntime_namespaceObject = require("@babel/runtime/helpers/regeneratorRuntime");
var regeneratorRuntime_default = /*#__PURE__*/__webpack_require__.n(regeneratorRuntime_namespaceObject);
;// external "@babel/runtime/helpers/asyncToGenerator"
const asyncToGenerator_namespaceObject = require("@babel/runtime/helpers/asyncToGenerator");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator_namespaceObject);
;// external "core-js/modules/es.error.cause.js"
const es_error_cause_js_namespaceObject = require("core-js/modules/es.error.cause.js");
;// external "core-js/modules/es.error.to-string.js"
const es_error_to_string_js_namespaceObject = require("core-js/modules/es.error.to-string.js");
;// external "core-js/modules/es.array.filter.js"
const es_array_filter_js_namespaceObject = require("core-js/modules/es.array.filter.js");
;// external "core-js/modules/es.array.iterator.js"
const es_array_iterator_js_namespaceObject = require("core-js/modules/es.array.iterator.js");
;// external "core-js/modules/es.promise.js"
const es_promise_js_namespaceObject = require("core-js/modules/es.promise.js");
;// external "core-js/modules/es.regexp.to-string.js"
const es_regexp_to_string_js_namespaceObject = require("core-js/modules/es.regexp.to-string.js");
;// external "core-js/modules/esnext.iterator.filter.js"
const esnext_iterator_filter_js_namespaceObject = require("core-js/modules/esnext.iterator.filter.js");
;// external "core-js/modules/web.dom-collections.iterator.js"
const web_dom_collections_iterator_js_namespaceObject = require("core-js/modules/web.dom-collections.iterator.js");
;// external "core-js/modules/web.url-search-params.js"
const web_url_search_params_js_namespaceObject = require("core-js/modules/web.url-search-params.js");
;// external "core-js/modules/web.url-search-params.delete.js"
const web_url_search_params_delete_js_namespaceObject = require("core-js/modules/web.url-search-params.delete.js");
;// external "core-js/modules/web.url-search-params.has.js"
const web_url_search_params_has_js_namespaceObject = require("core-js/modules/web.url-search-params.has.js");
;// external "core-js/modules/web.url-search-params.size.js"
const web_url_search_params_size_js_namespaceObject = require("core-js/modules/web.url-search-params.size.js");
;// external "frontend-logger"
const external_frontend_logger_namespaceObject = require("frontend-logger");
var external_frontend_logger_default = /*#__PURE__*/__webpack_require__.n(external_frontend_logger_namespaceObject);
;// external "react-hook-form"
const external_react_hook_form_namespaceObject = require("react-hook-form");
;// external "frontend-restclient"
const external_frontend_restclient_namespaceObject = require("frontend-restclient");
var external_frontend_restclient_default = /*#__PURE__*/__webpack_require__.n(external_frontend_restclient_namespaceObject);
;// external "@andes/progress-indicator-circular"
const progress_indicator_circular_namespaceObject = require("@andes/progress-indicator-circular");
var progress_indicator_circular_default = /*#__PURE__*/__webpack_require__.n(progress_indicator_circular_namespaceObject);
;// external "frontend-image"
const external_frontend_image_namespaceObject = require("frontend-image");
var external_frontend_image_default = /*#__PURE__*/__webpack_require__.n(external_frontend_image_namespaceObject);
;// external "@andes-landings/button"
const button_namespaceObject = require("@andes-landings/button");
;// external "core-js/modules/es.array.some.js"
const es_array_some_js_namespaceObject = require("core-js/modules/es.array.some.js");
;// external "core-js/modules/es.date.to-iso-string.js"
const es_date_to_iso_string_js_namespaceObject = require("core-js/modules/es.date.to-iso-string.js");
;// external "core-js/modules/es.object.entries.js"
const es_object_entries_js_namespaceObject = require("core-js/modules/es.object.entries.js");
// EXTERNAL MODULE: external "core-js/modules/es.object.values.js"
var es_object_values_js_ = __webpack_require__(5772);
;// external "core-js/modules/es.string.replace-all.js"
const es_string_replace_all_js_namespaceObject = require("core-js/modules/es.string.replace-all.js");
;// external "core-js/modules/es.string.starts-with.js"
const es_string_starts_with_js_namespaceObject = require("core-js/modules/es.string.starts-with.js");
;// external "core-js/modules/web.url.js"
const web_url_js_namespaceObject = require("core-js/modules/web.url.js");
;// external "core-js/modules/web.url.can-parse.js"
const web_url_can_parse_js_namespaceObject = require("core-js/modules/web.url.can-parse.js");
;// external "core-js/modules/web.url.to-json.js"
const web_url_to_json_js_namespaceObject = require("core-js/modules/web.url.to-json.js");
;// ./utils/src/stringifySrcset.js





var stringifySrcset = function stringifySrcset(imagePaths) {
  var resolutions = imagePaths ? Object.keys(imagePaths) : [];
  return resolutions.map(function (resolution) {
    return "".concat(imagePaths[resolution], " ").concat(resolution, "w");
  }).join(',');
};
;// ./utils/src/rebranding-images.js




var rebranding_images_excluded = ["imagePath", "imagePaths", "src"];





























var REBRAND_ASSETS_STORAGE = 'https://http2.mlstatic.com/storage/pog-cm-admin/calm-assets/';
var REBRAND_ALLOWED_DOMAINS = ['https://http2.mlstatic.com/frontend-assets/growth-sellers-landings/', 'https://http2.mlstatic.com/resources/frontend/gsl-assets/', 'https://http2.mlstatic.com/storage/mgrowth-cc-blue-hero/', REBRAND_ASSETS_STORAGE];
var REBRAND_ALLOWED_EXTENSIONS = ['png', 'jpeg', 'jpg', 'webp'];
var REBRAND_SUFFIX = '--rebrand-mp';
var REBRAND_IMAGE_EXTENSION = 'webp';
var isValidRebrandDomain = function isValidRebrandDomain(url) {
  return REBRAND_ALLOWED_DOMAINS.some(function (domain) {
    return url === null || url === void 0 ? void 0 : url.startsWith(domain);
  });
};
var clearNameFile = function clearNameFile(name) {
  return {
    cleanName: name === null || name === void 0 ? void 0 : name.split('.').shift()
  };
};
var getNameFromUrl = function getNameFromUrl(url) {
  if (!URL.canParse(url)) {
    return null;
  }
  var urlObject = new URL(url);
  return {
    path: urlObject.pathname,
    name: clearNameFile(urlObject.pathname.split('/').pop()).cleanName
  };
};
var rewriteURL = function rewriteURL(url) {
  var _getNameFromUrl;
  if (!(url !== null && url !== void 0 && url.length) || !URL.canParse(url)) {
    return '';
  }
  var extension = url.split('.').pop();
  if (!REBRAND_ALLOWED_EXTENSIONS.includes(extension) || !isValidRebrandDomain(url)) {
    return url;
  }
  var dateParam = "".concat(new Date().toISOString().split('T')[0].replaceAll('-', ''));
  var filename = (_getNameFromUrl = getNameFromUrl(url)) === null || _getNameFromUrl === void 0 ? void 0 : _getNameFromUrl.name;
  var rebrandFilename = "".concat(filename).concat(REBRAND_SUFFIX, ".").concat(REBRAND_IMAGE_EXTENSION, "?d=").concat(dateParam);
  return "".concat(REBRAND_ASSETS_STORAGE).concat(rebrandFilename);
};
var rewriteImagePaths = function rewriteImagePaths(imagePaths) {
  if (!imagePaths || typeof_default()(imagePaths) !== 'object' || Object.keys(imagePaths).length < 1) {
    return {};
  }
  var clone = {};
  Object.entries(imagePaths).forEach(function (_ref) {
    var _ref2 = slicedToArray_default()(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    clone["".concat(key)] = rewriteURL(value);
  });
  return clone;
};
var getImageProperties = function getImageProperties(image) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!image || typeof_default()(image) !== 'object' || Object.keys(image) < 1) {
    return null;
  }
  var _options$setDefaultSr = options.setDefaultSrc,
    setDefaultSrc = _options$setDefaultSr === void 0 ? false : _options$setDefaultSr,
    _options$setSrcSetStr = options.setSrcSetString,
    setSrcSetString = _options$setSrcSetStr === void 0 ? false : _options$setSrcSetStr,
    _options$setImagePath = options.setImagePathsObject,
    setImagePathsObject = _options$setImagePath === void 0 ? false : _options$setImagePath,
    _options$rewriteURLs = options.rewriteURLs,
    rewriteURLs = _options$rewriteURLs === void 0 ? false : _options$rewriteURLs;
  var imagePath = image.imagePath,
    imagePaths = image.imagePaths,
    initialSrc = image.src,
    otherProps = objectWithoutProperties_default()(image, rebranding_images_excluded);
  var clone = objectSpread2_default()({}, otherProps);
  var paths = imagePaths !== null && imagePaths !== void 0 ? imagePaths : imagePath;
  var src = initialSrc;
  if (rewriteURLs) {
    paths = objectSpread2_default()({}, rewriteImagePaths(paths));
    if (!src && paths) {
      var imagePathsValues = Object.values(paths);
      src = imagePathsValues.length > 0 ? imagePathsValues[0] : '';
    }
    src = rewriteURL(src);
  }
  if (setDefaultSrc) {
    var defaultPath = null;
    try {
      var _Object$values;
      // defaults to second element (768px resource)
      defaultPath = ((_Object$values = Object.values(paths)) === null || _Object$values === void 0 ? void 0 : _Object$values.length) > 1 ? Object.values(paths)[1] : '';
    } catch (err) {
      defaultPath = '';
    }
    clone.src = src !== null && src !== void 0 ? src : defaultPath;
  } else {
    clone.src = src;
  }
  if (setSrcSetString) {
    clone.srcset = stringifySrcset(paths);
  }
  if (setImagePathsObject) {
    clone.imagePaths = objectSpread2_default()({}, paths);
  }
  return clone;
};
;// ./components/molecules/form/src/Feedback.js


















var SUBMIT_SUCCESS = framework_namespaceObject.TRACKING_TRIGGERS.SUBMIT_SUCCESS,
  SUBMIT_ERROR = framework_namespaceObject.TRACKING_TRIGGERS.SUBMIT_ERROR,
  BUTTON_SUCCESS = framework_namespaceObject.TRACKING_TRIGGERS.BUTTON_SUCCESS,
  BUTTON_ERROR = framework_namespaceObject.TRACKING_TRIGGERS.BUTTON_ERROR;
var Feedback_namespace = 'pog-ui-form-feedback';
var FEEDBACK_SUCCESS = 'FeedbackSuccess';
var DEFAULT_ASSET = {
  icon: {
    name: FEEDBACK_SUCCESS
  }
};
var dispatchFormEventTrack = function dispatchFormEventTrack(handler, data) {
  if (!data || !handler || !handler.notifyMultipleTracks) {
    return;
  }
  try {
    var customTrackdata = data.customTrackdata,
      calmTrackdata = data.calmTrackdata;
    handler.notifyMultipleTracks(customTrackdata, calmTrackdata);
  } catch (err) {
    /* eslint-disable no-console */
    /* istanbul ignore next */
    console.error('ERROR: ', err);
    /* eslint-enable no-console */
  }
};
var Feedback = function Feedback(_ref) {
  var _image$src, _button$href, _button$title;
  var isMobile = _ref.isMobile,
    asset = _ref.asset,
    title = _ref.title,
    description = _ref.description,
    button = _ref.button,
    trackdata = _ref.trackdata,
    sectionMetadata = _ref.sectionMetadata;
  var trackingHandler = (0,framework_namespaceObject.useTracking)();
  var trackClick = (0,framework_namespaceObject.getDefaultEventTrackingFn)(trackingHandler);
  var _ref2 = (0,framework_namespaceObject.useCalmContext)() || {},
    _ref2$isRebrand = _ref2.isRebrand,
    isRebrand = _ref2$isRebrand === void 0 ? false : _ref2$isRebrand,
    _ref2$keepImageURLs = _ref2.keepImageURLs,
    keepImageURLs = _ref2$keepImageURLs === void 0 ? false : _ref2$keepImageURLs;
  var _ref3 = asset || DEFAULT_ASSET,
    _ref3$icon = _ref3.icon,
    icon = _ref3$icon === void 0 ? DEFAULT_ASSET.icon : _ref3$icon,
    originalImage = _ref3.image;
  var image = getImageProperties(originalImage, {
    setDefaultSrc: true,
    setSrcSetString: true,
    setImagePathsObject: true,
    rewriteURLs: isRebrand && !keepImageURLs
  });
  (0,external_react_namespaceObject.useEffect)(function () {
    var submitResult = icon.name === FEEDBACK_SUCCESS ? SUBMIT_SUCCESS : SUBMIT_ERROR;
    var formatedTrackData = (0,framework_namespaceObject.buildTracks)(trackdata, submitResult, sectionMetadata);
    dispatchFormEventTrack(trackingHandler, formatedTrackData);
  }, []);
  var hasImage = (image === null || image === void 0 || (_image$src = image.src) === null || _image$src === void 0 ? void 0 : _image$src.length) || (image === null || image === void 0 ? void 0 : image.imagePaths) && Object.keys(image === null || image === void 0 ? void 0 : image.imagePaths).length;
  var handleOnClick = function handleOnClick(ev) {
    var element = icon.name === FEEDBACK_SUCCESS ? BUTTON_SUCCESS : BUTTON_ERROR;
    var formatedTrackData = (0,framework_namespaceObject.buildTracks)(button.trackdata, element, sectionMetadata);
    trackClick(ev, formatedTrackData);
  };
  return /*#__PURE__*/jsx_default()("div", {
    className: external_classnames_default()("".concat(Feedback_namespace), "".concat(Feedback_namespace, "--").concat(isMobile ? 'mobile' : 'desktop'))
  }, void 0, hasImage ? /*#__PURE__*/jsx_default()((external_frontend_image_default()), {
    alt: image.alt,
    width: image.width || '',
    height: image.height || '',
    className: "".concat(Feedback_namespace, "__image"),
    src: "".concat(image.src),
    srcSet: "".concat(image.srcset)
  }) : /*#__PURE__*/jsx_default()(src_Icon, {
    className: "".concat(Feedback_namespace, "__icon"),
    name: (icon || DEFAULT_ASSET.icon).name,
    options: icon === null || icon === void 0 ? void 0 : icon.options
  }), /*#__PURE__*/jsx_default()(typography_namespaceObject.Typography, {
    type: "title",
    size: "m",
    className: "".concat(Feedback_namespace, "__title"),
    component: "h2"
  }, void 0, title), description && /*#__PURE__*/jsx_default()(typography_namespaceObject.Typography, {
    type: "body",
    size: "m",
    className: "".concat(Feedback_namespace, "__description"),
    component: hasParagraphTag(description) ? 'div' : 'p',
    contentHtml: true
  }, void 0, description), (button === null || button === void 0 ? void 0 : button.text) && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(button_namespaceObject.Button, objectSpread2_default()(objectSpread2_default()({}, button), {}, {
    target: "_self",
    className: "".concat(Feedback_namespace, "__button ").concat(button.className),
    href: button !== null && button !== void 0 && (_button$href = button.href) !== null && _button$href !== void 0 && _button$href.length ? button.href : null,
    handleClick: handleOnClick,
    children: (_button$title = button.title) !== null && _button$title !== void 0 ? _button$title : button.text
  })));
};
Feedback.defaultProps = {
  description: '',
  asset: DEFAULT_ASSET,
  button: null
};
/* harmony default export */ const src_Feedback = (Feedback);
;// external "frontend-script"
const external_frontend_script_namespaceObject = require("frontend-script");
;// external "frontend-style"
const external_frontend_style_namespaceObject = require("frontend-style");
;// ./components/molecules/form/src/Grecaptcha.js

var _Style, _Style2;








var Grecaptcha = function Grecaptcha(_ref) {
  var config = _ref.config;
  if (!(config !== null && config !== void 0 && config.key)) {
    return null;
  }
  var badge = config.position || 'bottomright';
  var scriptSource = "https://www.google.com/recaptcha/enterprise.js?render=".concat(config.key, "&badge=").concat(badge);
  var isSSR = typeof document === 'undefined';
  var scriptIsLoaded = !isSSR && document.querySelector('html').innerHTML.includes(scriptSource);
  if (scriptIsLoaded) {
    return null;
  }
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
    children: [/*#__PURE__*/jsx_default()(external_frontend_script_namespaceObject.Script, {
      async: true,
      defer: true,
      crossOrigin: null,
      src: scriptSource
    }), (config === null || config === void 0 ? void 0 : config.hidden) && (_Style || (_Style = _Style2 || (_Style2 = /*#__PURE__*/jsx_default()(external_frontend_style_namespaceObject.Style, {}, void 0, ".grecaptcha-badge { display: none; }"))))]
  });
};
/* harmony default export */ const src_Grecaptcha = (Grecaptcha);
;// ./components/molecules/structuredForm/src/constants/index.js
var FORM_NAMESPACE = 'pog-ui-structured-form';
var FORM_STEPS = {
  UNFILLED: 'Unfilled',
  SUCCESS: 'Success',
  ERROR: 'Error'
};
var constants_FEEDBACK_SUCCESS = 'FeedbackSuccess';
var FEEDBACK_ERROR = 'FeedbackError';
var REGEX_PATTERNS = {
  CPF_VALID_FORMAT: /^[\d.-]+$/,
  CLEAN_CPF: /[^\d]+/g,
  REPEATED_DIGITS_CPF: /^(\d)\1{10}$/,
  CNPJ_VALID_FORMAT: /^(\d{14}|\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2})$/
};

/* eslint-disable security/detect-unsafe-regex, eslint-comments/disable-enable-pair */
var PHONE_VALIDATION_PATTERNS = {
  MLA: /^(?:\+?54|00)?9?(\d{8}|\d{10})$/,
  MLB: /^(?:\+?55|00)?(?:\d{2})?(?:9\d{8}|\d{8})$/,
  MLC: /^(?:\+?56|00)?(?:9\d{8}|\d{9})$/,
  MCO: /^(?:\+?57|00)?(?:3\d{9}|6\d{9}|\d{7})$/,
  MLM: /^(?:\+?52|00)?(?:1?\d{10}|\d{10})$/,
  MPE: /^(?:\+?51|00)?(?:9\d{8}|\d{8})$/,
  MLU: /^(?:\+?598|00)?(?:9\d{7}|\d{8})$/,
  MUS: /^(?:\+?1|00)?[2-9]\d{2}[2-9]\d{6}$/
};
/* eslint-enable security/detect-unsafe-regex */

var FORMATTED_INPUT_SUFFIX = '-input-formatted';
;// external "lodash"
const external_lodash_namespaceObject = require("lodash");
;// external "@andes/checkbox"
const checkbox_namespaceObject = require("@andes/checkbox");
var checkbox_default = /*#__PURE__*/__webpack_require__.n(checkbox_namespaceObject);
;// external "@andes/icons/FeedbackNegative12"
const FeedbackNegative12_namespaceObject = require("@andes/icons/FeedbackNegative12");
var FeedbackNegative12_default = /*#__PURE__*/__webpack_require__.n(FeedbackNegative12_namespaceObject);
;// ./components/molecules/structuredForm/src/fields/FieldError.js

var _span, _span2;



var FieldError = function FieldError(_ref) {
  var message = _ref.message;
  return /*#__PURE__*/jsx_default()("div", {
    className: "andes-form-control__bottom"
  }, void 0, _span || (_span = _span2 || (_span2 = /*#__PURE__*/jsx_default()("span", {
    className: "andes-form-control__error-icon",
    "aria-hidden": "true"
  }, void 0, /*#__PURE__*/jsx_default()((FeedbackNegative12_default()), {
    color: "white"
  })))), /*#__PURE__*/jsx_default()("span", {
    className: "andes-form-control__message"
  }, void 0, message));
};
/* harmony default export */ const fields_FieldError = (FieldError);
;// ./components/molecules/structuredForm/src/fields/Checkbox.js














var Checkbox = function Checkbox(_ref) {
  var name = _ref.name,
    label = _ref.label,
    required = _ref.required,
    validationMessage = _ref.validationMessage,
    className = _ref.className,
    size = _ref.size,
    error = _ref.error,
    register = _ref.registerFn,
    setValue = _ref.setValue;
  var _useState = (0,external_react_namespaceObject.useState)(false),
    _useState2 = slicedToArray_default()(_useState, 2),
    checked = _useState2[0],
    setChecked = _useState2[1];
  var namespace = FORM_NAMESPACE;
  var registerProps = register(name, {
    required: required,
    value: checked
  });
  var onChange = function onChange(e) {
    var newValue = e.target.checked;
    setValue(name, newValue);
    setChecked(newValue);
    registerProps.onChange(e);
  };
  return /*#__PURE__*/jsx_default()("div", {
    className: external_classnames_default()('andes-form-control', "".concat(namespace, "__checkbox"), "".concat(namespace, "__field--").concat(size || 100), error ? "".concat(namespace, "__error andes-form-control--error") : '', className)
  }, void 0, /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)((checkbox_default()), objectSpread2_default()(objectSpread2_default()({}, registerProps), {}, {
    label: label ? /*#__PURE__*/jsx_default()(typography_namespaceObject.Typography, {
      component: "span",
      contentHtml: true
    }, void 0, label) : null,
    error: !!error,
    onChange: onChange
  })), error && !checked && /*#__PURE__*/jsx_default()(fields_FieldError, {
    message: validationMessage
  }));
};
Checkbox.defaultValues = {
  registerFn: external_lodash_namespaceObject.noop
};
Checkbox.fieldName = 'Checkbox';
;// external "@andes/checkbox-list"
const checkbox_list_namespaceObject = require("@andes/checkbox-list");
var checkbox_list_default = /*#__PURE__*/__webpack_require__.n(checkbox_list_namespaceObject);
;// ./components/molecules/structuredForm/src/fields/CheckboxGroup.js
















var CheckboxGroup = function CheckboxGroup(_ref) {
  var id = _ref.id,
    name = _ref.name,
    label = _ref.label,
    className = _ref.className,
    options = _ref.options,
    required = _ref.required,
    validationMessage = _ref.validationMessage,
    size = _ref.size,
    srLabel = _ref.srLabel,
    error = _ref.error,
    control = _ref.control;
  var _useState = (0,external_react_namespaceObject.useState)([]),
    _useState2 = slicedToArray_default()(_useState, 2),
    checkboxValues = _useState2[0],
    setCheckboxValues = _useState2[1];
  var namespace = FORM_NAMESPACE;
  return /*#__PURE__*/jsx_default()("div", {
    className: external_classnames_default()('andes-form-control', "".concat(namespace, "__checkbox-group"), "".concat(namespace, "__field--").concat(size || 100), error ? "".concat(namespace, "__error andes-form-control--error") : '', className)
  }, name, label && /*#__PURE__*/jsx_default()("h3", {
    className: "andes-form-control__label"
  }, void 0, label), /*#__PURE__*/jsx_default()(external_react_hook_form_namespaceObject.Controller, {
    name: name,
    control: control,
    render: function render(_ref2) {
      var field = _ref2.field;
      var _onChange = field.onChange,
        value = field.value;
      return /*#__PURE__*/jsx_default()((checkbox_list_default()), {
        id: id,
        srLabel: srLabel,
        value: value,
        onChange: function onChange(e, newValue) {
          _onChange(newValue);
          setCheckboxValues(newValue);
        },
        modifier: error ? 'error' : 'default'
      }, void 0, options.map(function (item) {
        return /*#__PURE__*/jsx_default()(checkbox_list_namespaceObject.CheckboxListItem, {
          title: item.text,
          value: item.value,
          description: item.description,
          size: "small"
        }, "name-".concat(name, "-option-").concat(item.value));
      }));
    },
    rules: {
      required: required ? validationMessage : false
    }
  }), error && !(checkboxValues !== null && checkboxValues !== void 0 && checkboxValues.length) && /*#__PURE__*/jsx_default()(fields_FieldError, {
    className: "".concat(namespace, "__error"),
    message: validationMessage
  }));
};
CheckboxGroup.defaultValues = {
  registerFn: external_lodash_namespaceObject.noop
};
CheckboxGroup.fieldName = 'CheckboxGroup';
;// external "@andes/dropdown"
const dropdown_namespaceObject = require("@andes/dropdown");
var dropdown_default = /*#__PURE__*/__webpack_require__.n(dropdown_namespaceObject);
;// ./components/molecules/structuredForm/src/fields/Dropdown.js











var Dropdown = function Dropdown(_ref) {
  var name = _ref.name,
    label = _ref.label,
    placeholder = _ref.placeholder,
    required = _ref.required,
    validationMessage = _ref.validationMessage,
    options = _ref.options,
    className = _ref.className,
    size = _ref.size,
    error = _ref.error,
    control = _ref.control;
  var namespace = FORM_NAMESPACE;
  return /*#__PURE__*/jsx_default()(external_react_hook_form_namespaceObject.Controller, {
    render: function render(_ref2) {
      var _ref2$field = _ref2.field,
        _onChange = _ref2$field.onChange,
        value = _ref2$field.value;
      return /*#__PURE__*/jsx_default()((dropdown_default()), {
        className: external_classnames_default()("".concat(namespace, "__dropdown"), "".concat(namespace, "__field--").concat(size || 100), className, !label && "".concat(namespace, "__dropdown--no-label")),
        placeholder: placeholder,
        label: label !== null && label !== void 0 ? label : '',
        type: "form",
        modifier: error ? 'error' : null,
        helper: error === null || error === void 0 ? void 0 : error.message,
        value: value,
        onChange: function onChange(_, newValue) {
          return _onChange(newValue);
        },
        menuAlignment: "center",
        menuMaxHeight: 222
      }, name, options.map(function (item) {
        return /*#__PURE__*/jsx_default()(dropdown_namespaceObject.DropdownItem, {
          value: item.value,
          title: item.text
        }, "name-".concat(name, "-key-").concat(item.value));
      }));
    },
    control: control,
    name: name,
    rules: {
      required: required ? validationMessage : false
    }
  });
};
Dropdown.fieldName = 'Dropdown';
;// ./components/molecules/structuredForm/src/fields/Gap.js






var Gap = function Gap(_ref) {
  var size = _ref.size;
  var namespace = FORM_NAMESPACE;
  return /*#__PURE__*/jsx_default()("div", {
    className: external_classnames_default()("".concat(namespace, "__field--").concat(size), 'andes-form-control', "".concat(namespace, "__field-gap"))
  }, "gap");
};
Gap.fieldName = 'Gap';
;// external "@andes/radio-button"
const radio_button_namespaceObject = require("@andes/radio-button");
var radio_button_default = /*#__PURE__*/__webpack_require__.n(radio_button_namespaceObject);
;// ./components/molecules/structuredForm/src/fields/Radio.js













var Radio = function Radio(_ref) {
  var name = _ref.name,
    label = _ref.label,
    required = _ref.required,
    validationMessage = _ref.validationMessage,
    options = _ref.options,
    className = _ref.className,
    size = _ref.size,
    error = _ref.error,
    control = _ref.control;
  var namespace = FORM_NAMESPACE;
  return /*#__PURE__*/jsx_default()("div", {
    className: external_classnames_default()('andes-form-control', "".concat(namespace, "__radio"), "".concat(namespace, "__field--").concat(size || 100), error ? "".concat(namespace, "__error andes-form-control--error") : '', className)
  }, name, label && /*#__PURE__*/jsx_default()("h3", {
    className: "andes-form-control__label"
  }, void 0, label), /*#__PURE__*/jsx_default()(external_react_hook_form_namespaceObject.Controller, {
    name: name,
    control: control,
    render: function render(_ref2) {
      var field = _ref2.field;
      var _onChange = field.onChange,
        value = field.value;
      return /*#__PURE__*/jsx_default()(radio_button_namespaceObject.RadioGroup, {
        inline: true,
        value: value,
        onChange: function onChange(_, newValue) {
          return _onChange(newValue || _.target.value);
        },
        name: "".concat(name)
      }, name, options.map(function (_ref3) {
        var optionValue = _ref3.value,
          text = _ref3.text;
        return /*#__PURE__*/jsx_default()((radio_button_default()), {
          error: !!error,
          id: "id-".concat(optionValue),
          name: optionValue,
          value: optionValue,
          label: text
        }, "name-".concat(name, "-key-").concat(optionValue));
      }));
    },
    rules: {
      required: required ? validationMessage : false
    }
  }), error && /*#__PURE__*/jsx_default()(fields_FieldError, {
    message: validationMessage
  }));
};
Radio.fieldName = 'Radio';
;// external "core-js/modules/es.regexp.constructor.js"
const es_regexp_constructor_js_namespaceObject = require("core-js/modules/es.regexp.constructor.js");
;// external "core-js/modules/es.regexp.dot-all.js"
const es_regexp_dot_all_js_namespaceObject = require("core-js/modules/es.regexp.dot-all.js");
;// external "core-js/modules/es.regexp.sticky.js"
const es_regexp_sticky_js_namespaceObject = require("core-js/modules/es.regexp.sticky.js");
;// external "core-js/modules/es.regexp.test.js"
const es_regexp_test_js_namespaceObject = require("core-js/modules/es.regexp.test.js");
;// external "core-js/modules/es.string.repeat.js"
const es_string_repeat_js_namespaceObject = require("core-js/modules/es.string.repeat.js");
;// external "@andes/textfield"
const textfield_namespaceObject = require("@andes/textfield");
var textfield_default = /*#__PURE__*/__webpack_require__.n(textfield_namespaceObject);
;// ./components/molecules/form/src/Flags.js

var _Icon, _Icon2, _Icon3, _Icon4, _Icon5, _Icon6, _Icon7, _Icon8, _Icon9, _Icon10, _Icon11, _Icon12, _Icon13, _Icon14, _Icon15, _Icon16;


var Flags = {
  MLA: {
    icon: function icon() {
      return _Icon || (_Icon = _Icon2 || (_Icon2 = /*#__PURE__*/jsx_default()(src_Icon, {
        className: "flag-icon",
        name: "FlagMLA"
      })));
    },
    id: 'MLA',
    title: '+54'
  },
  MLB: {
    icon: function icon() {
      return _Icon3 || (_Icon3 = _Icon4 || (_Icon4 = /*#__PURE__*/jsx_default()(src_Icon, {
        className: "flag-icon",
        name: "FlagMLB"
      })));
    },
    id: 'MLB',
    title: '+55'
  },
  MLC: {
    icon: function icon() {
      return _Icon5 || (_Icon5 = _Icon6 || (_Icon6 = /*#__PURE__*/jsx_default()(src_Icon, {
        className: "flag-icon",
        name: "FlagMLC"
      })));
    },
    id: 'MLC',
    title: '+56'
  },
  MCO: {
    icon: function icon() {
      return _Icon7 || (_Icon7 = _Icon8 || (_Icon8 = /*#__PURE__*/jsx_default()(src_Icon, {
        className: "flag-icon",
        name: "FlagMCO"
      })));
    },
    id: 'MCO',
    title: '+57'
  },
  MLM: {
    icon: function icon() {
      return _Icon9 || (_Icon9 = _Icon10 || (_Icon10 = /*#__PURE__*/jsx_default()(src_Icon, {
        className: "flag-icon",
        name: "FlagMLM"
      })));
    },
    id: 'MLM',
    title: '+52'
  },
  MPE: {
    icon: function icon() {
      return _Icon11 || (_Icon11 = _Icon12 || (_Icon12 = /*#__PURE__*/jsx_default()(src_Icon, {
        className: "flag-icon",
        name: "FlagMPE"
      })));
    },
    id: 'MPE',
    title: '+51'
  },
  MLU: {
    icon: function icon() {
      return _Icon13 || (_Icon13 = _Icon14 || (_Icon14 = /*#__PURE__*/jsx_default()(src_Icon, {
        className: "flag-icon",
        name: "FlagMLU"
      })));
    },
    id: 'MLU',
    title: '+598'
  },
  MUS: {
    icon: function icon() {
      return _Icon15 || (_Icon15 = _Icon16 || (_Icon16 = /*#__PURE__*/jsx_default()(src_Icon, {
        className: "flag-icon",
        name: "FlagMUS"
      })));
    },
    id: 'MUS',
    title: '+1'
  }
};
var FlagsList = [Flags.MLA, Flags.MLB, Flags.MLC, Flags.MCO, Flags.MLM, Flags.MPE, Flags.MLU, Flags.MUS];
;// external "core-js/modules/es.array.reduce.js"
const es_array_reduce_js_namespaceObject = require("core-js/modules/es.array.reduce.js");
;// external "core-js/modules/esnext.iterator.reduce.js"
const esnext_iterator_reduce_js_namespaceObject = require("core-js/modules/esnext.iterator.reduce.js");
;// ./components/molecules/structuredForm/src/helpers/formatter.js













/* eslint-disable no-continue */

/*
code inspired in text-marshall package (no longer maintained)
https://www.npmjs.com/package/text-marshal
*/

function setCharAt(str, index, chr) {
  if (index > str.length - 1) {
    return str;
  }
  return str.substring(0, index) + chr + str.substring(index + 1);
}
function letterCount(str, letter) {
  if (!str) {
    return 0;
  }
  return str.split('').reduce(function (acc, ch) {
    return ch === letter ? acc + 1 : acc;
  }, 0);
}
function charExists(str, subStrArr) {
  if (!str) {
    return 0;
  }
  var y = 0;
  var bool = false;
  while (y < subStrArr.length) {
    if (typeof subStrArr[y] === 'number' || typeof subStrArr[y] === 'string') {
      if (str.includes(subStrArr[y])) {
        bool = true;
        break;
      }
    } else {
      var regex = subStrArr[y];
      if (regex.test(str)) {
        bool = true;
      }
    }
    y += 1;
  }
  return !!bool;
}
function formatInput(_ref) {
  var _ref$input = _ref.input,
    input = _ref$input === void 0 ? '' : _ref$input,
    _ref$template = _ref.template,
    templateInput = _ref$template === void 0 ? '' : _ref$template,
    _ref$disallowCharacte = _ref.disallowCharacters,
    disallowCharacters = _ref$disallowCharacte === void 0 ? [] : _ref$disallowCharacte,
    _ref$repetition = _ref.repetition,
    _ref$repetition2 = _ref$repetition === void 0 ? {
      value: false,
      removeStart: false
    } : _ref$repetition,
    value = _ref$repetition2.value,
    removeStart = _ref$repetition2.removeStart;
  try {
    var template = templateInput.toLowerCase();
    if (value && input.length > (0, letterCount)(template, 'x')) {
      template = template.repeat(Math.ceil(input.length / (0, letterCount)(template, 'x')));
    }
    if (removeStart && !template.startsWith('x')) {
      template = (0, setCharAt)(template, 0, '');
    }
    var templateclone = template;
    var j = 0;
    var plainText = '';
    var countj = 0;
    while (j < template.length) {
      // code block to be
      if (countj > input.length - 1) {
        template = template.substring(0, j);
        templateclone = templateclone.substring(0, j);
        break;
      }
      if (template[j] === input[j]) {
        j += 1;
        countj += 1;
        continue;
      }
      if (disallowCharacters && (0, charExists)(input[countj], disallowCharacters)) {
        countj += 1;
        continue;
      }
      if (template[j] === 'x') {
        template = (0, setCharAt)(template, j, input[countj]);
        plainText += input[countj];
        countj += 1;
      }
      j += 1;
    }
    return {
      template: templateclone,
      plainText: plainText,
      formattedText: template
    };
  } catch (_unused) {
    return {
      template: '',
      plainText: '',
      formattedText: ''
    };
  }
}
var cleanFormattedInputs = function cleanFormattedInputs(data) {
  return Object.keys(data).reduce(function (allInputs, input) {
    if (input.includes('input-formatted')) {
      return allInputs;
    }
    return objectSpread2_default()(objectSpread2_default()({}, allInputs), {}, defineProperty_default()({}, input, data[input]));
  }, {});
};
;// ./components/molecules/structuredForm/src/helpers/constants.js
var MESSAGES = {
  ERROR_VALIDATION: 'The expression could not be resolved.'
};
var VALIDATIONS = {
  REGEX_LIMIT: 80
};
var PRIVACY_FIELD_NAME = 'terms';
var ERROR_PRIVACY_MESSAGE = {
  EN: 'This field is mandatory',
  ES: 'Este campo es obligatorio',
  PT: 'Este campo é obrigatório'
};
;// ./components/molecules/structuredForm/src/fields/SplitTextField.js





















var SplitTextField = function SplitTextField(_ref) {
  var className = _ref.className,
    disableIconFlags = _ref.disableIconFlags,
    error = _ref.error,
    formatMessage = _ref.formatMessage,
    formattingOptions = _ref.formattingOptions,
    getValues = _ref.getValues,
    label = _ref.label,
    maxLength = _ref.maxLength,
    name = _ref.name,
    placeholder = _ref.placeholder,
    register = _ref.registerFn,
    registerName = _ref.registerName,
    required = _ref.required,
    setValue = _ref.setValue,
    siteId = _ref.siteId,
    size = _ref.size,
    srLabel = _ref.srLabel,
    type = _ref.type,
    validationMessage = _ref.validationMessage;
  var _useState = (0,external_react_namespaceObject.useState)(Flags["".concat(siteId)] ? Flags["".concat(siteId)] : Flags.MLA),
    _useState2 = slicedToArray_default()(_useState, 2),
    split = _useState2[0],
    setSplit = _useState2[1];
  var _useState3 = (0,external_react_namespaceObject.useState)(''),
    _useState4 = slicedToArray_default()(_useState3, 2),
    inputValue = _useState4[0],
    setInputValue = _useState4[1];
  if (!register || !name) {
    return null;
  }
  var _ref2 = formattingOptions || {},
    format = _ref2.format,
    cleanValue = _ref2.cleanValue,
    repeat = _ref2.repeat;
  var namespace = FORM_NAMESPACE;
  var pattern = {
    value: PHONE_VALIDATION_PATTERNS[siteId] || /^\d+$/,
    message: formatMessage || validationMessage
  };
  var REMOVE_SPECIAL_CARACTERS = /[^0-9 ]/g;
  var prefix = split.title.replace(REMOVE_SPECIAL_CARACTERS, '');
  var registerProps = register(registerName, {
    validate: function validate() {
      var currentValue = getValues(name);
      var value = pattern.value,
        errorMessage = pattern.message;
      if (!currentValue && required) {
        return validationMessage;
      }
      try {
        var _RegExp;
        // eslint-disable-next-line security/detect-non-literal-regexp
        return (_RegExp = new RegExp(value)) !== null && _RegExp !== void 0 && _RegExp.test(currentValue) ? undefined : errorMessage;
      } catch (err) {
        return MESSAGES.ERROR_VALIDATION;
      }
    }
  });
  var setValues = function setValues(value) {
    if (format) {
      var newValue = formatInput({
        input: value,
        template: format,
        repetition: {
          value: repeat
        }
      });
      var hiddenValue = cleanValue ? newValue.plainText : newValue.formattedText;
      setInputValue(newValue.formattedText);
      setValue(name, "".concat(prefix).concat(hiddenValue));
    } else {
      setInputValue(value);
      setValue(name, "".concat(prefix).concat(value));
    }
  };
  var onBlur = function onBlur(e) {
    var _e$target;
    setValues((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value);
    registerProps.onBlur(e);
  };
  var onChange = function onChange(e) {
    var _e$target2;
    setValues((_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.value);
  };
  return /*#__PURE__*/(0,external_react_namespaceObject.createElement)(textfield_namespaceObject.SplitTextfield, objectSpread2_default()(objectSpread2_default()({}, registerProps), {}, {
    className: external_classnames_default()("".concat(namespace, "__text"), "".concat(namespace, "__splittext"), "".concat(namespace, "__").concat(type), "".concat(namespace, "__field--").concat(size || 100), className),
    label: label !== null && label !== void 0 ? label : '',
    srLabel: srLabel !== null && srLabel !== void 0 ? srLabel : '',
    placeholder: placeholder,
    modifier: error ? 'error' : null,
    helper: error === null || error === void 0 ? void 0 : error.message,
    list: {
      content: FlagsList,
      onClick: function onClick(e) {
        return setSplit(e);
      }
    },
    splitLabel: split.title,
    splitIcon: disableIconFlags ? null : split.icon(),
    onBlur: onBlur,
    key: name,
    maxLength: maxLength,
    value: inputValue,
    onChange: onChange
  }));
};
SplitTextField.defaultValues = {
  registerFn: external_lodash_namespaceObject.noop
};
SplitTextField.fieldName = 'SplitTextField';
;// ./components/molecules/structuredForm/src/fields/TextField.js


















var TEXTFIELD_TYPES = {
  TEXT: 'text',
  EMAIL: 'email',
  NUMBER: 'number',
  MULTILINE: 'multiline'
};
var TextField = function TextField(_ref) {
  var className = _ref.className,
    error = _ref.error,
    formatMessage = _ref.formatMessage,
    formattingOptions = _ref.formattingOptions,
    getValues = _ref.getValues,
    label = _ref.label,
    maxLength = _ref.maxLength,
    name = _ref.name,
    placeholder = _ref.placeholder,
    register = _ref.registerFn,
    registerName = _ref.registerName,
    required = _ref.required,
    setValue = _ref.setValue,
    size = _ref.size,
    srLabel = _ref.srLabel,
    type = _ref.type,
    validationMessage = _ref.validationMessage;
  var _ref2 = formattingOptions || {},
    format = _ref2.format,
    cleanValue = _ref2.cleanValue,
    repeat = _ref2.repeat;
  var _useState = (0,external_react_namespaceObject.useState)(''),
    _useState2 = slicedToArray_default()(_useState, 2),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  if (!register || !name || !type) {
    return null;
  }
  var namespace = FORM_NAMESPACE;
  var message = formatMessage || validationMessage;
  var validationRules = {
    text: {
      value: /^[\w .,ÁáÀàÂâÃãÉéÊêÍíÓóÔôÕõÚúÜüÇçÑñ]+$/,
      message: message
    },
    email: {
      value: /^([^\s@]{1,64})@[^\s@]{1,64}\.\S{2,10}$/,
      message: message
    },
    number: {
      value: /^\d+$/,
      message: message
    },
    multiline: {
      value: /^[\w\s.,ÁáÀàÂâÃãÉéÊêÍíÓóÔôÕõÚúÜüÇçÑñ]+$/,
      message: message
    }
  };
  var onChange = function onChange(e) {
    if (format) {
      var newValue = formatInput({
        input: e.target.value,
        template: format,
        repetition: {
          value: repeat
        }
      });
      var hiddenValue = cleanValue ? newValue.plainText : newValue.formattedText;
      setInputValue(newValue.formattedText);
      setValue(name, hiddenValue);
    } else {
      setInputValue(e.target.value);
      setValue(name, e.target.value);
    }
  };
  return /*#__PURE__*/(0,external_react_namespaceObject.createElement)((textfield_default()), objectSpread2_default()(objectSpread2_default()({}, register(registerName, {
    validate: function validate() {
      var _RegExp;
      var currentValue = getValues(name);
      var _validationRules$type = validationRules[type],
        value = _validationRules$type.value,
        errorMessage = _validationRules$type.message;
      if (!currentValue && required) {
        return validationMessage;
      }

      // eslint-disable-next-line security/detect-non-literal-regexp
      return (_RegExp = new RegExp(value)) !== null && _RegExp !== void 0 && _RegExp.test(currentValue) ? undefined : errorMessage;
    }
  })), {}, {
    className: external_classnames_default()("".concat(namespace, "__text"), "".concat(namespace, "__").concat(type), "".concat(namespace, "__field--").concat(size || 100), className),
    label: label,
    srLabel: srLabel !== null && srLabel !== void 0 ? srLabel : '',
    placeholder: placeholder,
    modifier: error ? 'error' : null,
    helper: error === null || error === void 0 ? void 0 : error.message,
    multiline: type === TEXTFIELD_TYPES.MULTILINE,
    key: name,
    maxLength: maxLength,
    value: inputValue,
    onChange: onChange
  }));
};
TextField.defaultValues = {
  registerFn: external_lodash_namespaceObject.noop
};
TextField.fieldName = 'TextField';
;// ./components/molecules/structuredForm/src/helpers/validations.js





var CPF_VALID_FORMAT = REGEX_PATTERNS.CPF_VALID_FORMAT,
  CLEAN_CPF = REGEX_PATTERNS.CLEAN_CPF,
  REPEATED_DIGITS_CPF = REGEX_PATTERNS.REPEATED_DIGITS_CPF,
  CNPJ_VALID_FORMAT = REGEX_PATTERNS.CNPJ_VALID_FORMAT;
var validateCPF = function validateCPF(cpf) {
  var isValidFormat = CPF_VALID_FORMAT.test(cpf);
  if (!isValidFormat) {
    return false;
  }
  var cleanCPF = cpf.replace(CLEAN_CPF, '');
  if (cleanCPF.length !== 11 || REPEATED_DIGITS_CPF.test(cleanCPF)) {
    return false;
  }
  var calculateVerifierDigit = function calculateVerifierDigit(cpfString, factor) {
    var sum = 0;
    for (var i = 0; i < factor - 1; i += 1) {
      sum += parseInt(cpfString[i], 10) * (factor - i);
    }
    var remainder = sum * 10 % 11;
    return remainder >= 10 ? 0 : remainder;
  };
  var firstVerifierDigit = calculateVerifierDigit(cleanCPF, 10);
  if (firstVerifierDigit !== parseInt(cleanCPF[9], 10)) {
    return false;
  }
  var secondVerifierDigit = calculateVerifierDigit(cleanCPF, 11);
  if (secondVerifierDigit !== parseInt(cleanCPF[10], 10)) {
    return false;
  }
  return true;
};
var validateCNPJ = function validateCNPJ(dirtyCNPJ) {
  var isValidFormat = CNPJ_VALID_FORMAT.test(dirtyCNPJ);
  if (!isValidFormat) {
    return false;
  }

  // Remove non-numeric characters (dots, slashes, and hyphens)
  var cnpj = "".concat(dirtyCNPJ).replace(/[^\d]+/g, '');

  // Check if the CNPJ has 14 digits
  if (cnpj.length !== 14) {
    return false;
  }

  // Check if all digits are the same (e.g., 11111111111111)
  if (/^(\d)\1{13}$/.test(cnpj)) {
    return false;
  }

  // Calculanting Digits

  var calculateVerifierDigit = function calculateVerifierDigit() {
    var charPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var length = cnpj.length - (2 - charPosition);
    var numbers = cnpj.substring(0, length);
    var checkDigit = cnpj.charAt(length);
    var sum = 0;
    var position = length - 7;
    for (var i = 0; i < length; i += 1) {
      sum += numbers.charAt(i) * position;
      position -= 1;
      if (position < 2) {
        position = 9;
      }
    }
    var result = sum % 11 < 2 ? 0 : 11 - sum % 11;
    return result === parseInt(checkDigit, 10);
  };
  if (!calculateVerifierDigit(0)) {
    return false;
  }
  if (!calculateVerifierDigit(1)) {
    return false;
  }
  return true;
};
;// ./components/molecules/structuredForm/src/fields/CustomPatternTextField.js




















var CustomPatternTextField = function CustomPatternTextField(_ref) {
  var name = _ref.name,
    type = _ref.type,
    label = _ref.label,
    srLabel = _ref.srLabel,
    placeholder = _ref.placeholder,
    required = _ref.required,
    validationMessage = _ref.validationMessage,
    formatMessage = _ref.formatMessage,
    className = _ref.className,
    size = _ref.size,
    maxLength = _ref.maxLength,
    error = _ref.error,
    register = _ref.registerFn,
    registerName = _ref.registerName,
    setValue = _ref.setValue,
    getValues = _ref.getValues,
    formattingOptions = _ref.formattingOptions,
    validation = _ref.validation;
  var _useState = (0,external_react_namespaceObject.useState)(''),
    _useState2 = slicedToArray_default()(_useState, 2),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  if (!register || !name || !type) {
    return null;
  }
  var _ref2 = formattingOptions || {},
    format = _ref2.format,
    cleanValue = _ref2.cleanValue,
    repeat = _ref2.repeat;
  var namespace = FORM_NAMESPACE;
  var message = formatMessage || validationMessage;
  var validationRules = {
    cpf: {
      value: validateCPF,
      message: message
    },
    cnpj: {
      value: validateCNPJ,
      message: message
    },
    custom: {
      value: function value(currentValue, regex) {
        try {
          var _RegExp;
          var newRegex = regex.substring(0, VALIDATIONS.REGEX_LIMIT);

          // eslint-disable-next-line security/detect-non-literal-regexp
          return (_RegExp = new RegExp(newRegex)) === null || _RegExp === void 0 ? void 0 : _RegExp.test(currentValue);
        } catch (err) {
          return MESSAGES.ERROR_VALIDATION;
        }
      },
      message: message
    }
  };
  var onChange = function onChange(e) {
    if (format) {
      var newValue = formatInput({
        input: e.target.value,
        template: format,
        repetition: {
          value: repeat
        }
      });
      var hiddenValue = cleanValue ? newValue.plainText : newValue.formattedText;
      setInputValue(newValue.formattedText);
      setValue(name, hiddenValue);
    } else {
      setInputValue(e.target.value);
      setValue(name, e.target.value);
    }
  };
  var validationRule = validationRules[type];
  return /*#__PURE__*/(0,external_react_namespaceObject.createElement)((textfield_default()), objectSpread2_default()(objectSpread2_default()({}, register(registerName, {
    validate: function validate() {
      var currentValue = getValues(name);
      if (!currentValue && required) {
        return validationMessage;
      }
      var isValid;
      if (validation) {
        isValid = validationRule === null || validationRule === void 0 ? void 0 : validationRule.value(currentValue, validation);
      } else {
        isValid = validationRule === null || validationRule === void 0 ? void 0 : validationRule.value(currentValue);
      }
      return isValid || (validationRule === null || validationRule === void 0 ? void 0 : validationRule.message);
    }
  })), {}, {
    className: external_classnames_default()("".concat(namespace, "__text"), "".concat(namespace, "__").concat(type), "".concat(namespace, "__field--").concat(size || 100), className),
    label: label,
    srLabel: srLabel !== null && srLabel !== void 0 ? srLabel : '',
    placeholder: placeholder,
    modifier: error ? 'error' : null,
    helper: error === null || error === void 0 ? void 0 : error.message,
    key: name,
    maxLength: maxLength,
    value: inputValue,
    onChange: onChange
  }));
};
CustomPatternTextField.defaultValues = {
  registerFn: external_lodash_namespaceObject.noop
};
CustomPatternTextField.fieldName = 'CustomPatternTextField';
;// ./components/molecules/structuredForm/src/helpers/renderFields.js






















var COMPONENTS_MAP = {
  text: TextField,
  email: TextField,
  number: TextField,
  multiline: TextField,
  phone: SplitTextField,
  cpf: CustomPatternTextField,
  cnpj: CustomPatternTextField,
  radio: Radio,
  dropdown: Dropdown,
  checkbox: Checkbox,
  checkboxGroup: CheckboxGroup,
  gap: Gap,
  custom: CustomPatternTextField
};
var renderField = function renderField(field, errors, utils, key) {
  var type = field.type,
    name = field.name,
    format = field.formattingOptions;
  var _ref = utils || {},
    registerFn = _ref.registerFn,
    getValues = _ref.getValues,
    setValue = _ref.setValue,
    control = _ref.control;
  var inputName = format ? "".concat(name).concat(FORMATTED_INPUT_SUFFIX) : name;
  var fieldError = (errors === null || errors === void 0 ? void 0 : errors[inputName]) || null;
  var Component = COMPONENTS_MAP[type];
  var componentName = Component.fieldName;
  var formHandlers = {};
  if (['TextField', 'SplitTextField', 'Checkbox', 'CustomPatternTextField'].includes(componentName)) {
    formHandlers.registerFn = registerFn;
    formHandlers.getValues = getValues;
    formHandlers.setValue = setValue;
  }
  if (['Radio', 'Dropdown', 'CheckboxGroup'].includes(componentName)) {
    formHandlers.control = control;
  }
  return /*#__PURE__*/(0,external_react_namespaceObject.createElement)(Component, objectSpread2_default()(objectSpread2_default()({}, field), {}, {
    key: "field-".concat(type, "-").concat(key),
    registerName: inputName,
    error: fieldError
  }, formHandlers));
};
var renderFields = function renderFields(fields, privacyField, errors, utils) {
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
    children: [fields.filter(function (field) {
      return field.type && (field.name || field.type === 'gap') && (field.name !== PRIVACY_FIELD_NAME || !privacyField) && COMPONENTS_MAP[field.type];
    }).map(function (field, key) {
      return renderField(field, errors, utils, key);
    }), privacyField && renderField(privacyField, errors, utils, fields.length)]
  });
};
;// ./components/molecules/structuredForm/src/helpers/createPrivacyField.js

var createPrivacyField = function createPrivacyField(privacyConfig, language) {
  return privacyConfig !== null && privacyConfig !== void 0 && privacyConfig.label ? {
    name: PRIVACY_FIELD_NAME,
    type: 'checkbox',
    label: privacyConfig.label,
    required: true,
    validationMessage: ERROR_PRIVACY_MESSAGE[language] || ERROR_PRIVACY_MESSAGE.ES
  } : null;
};
;// ./components/molecules/structuredForm/src/StructuredForm.js






var StructuredForm_excluded = ["className", "isMobile", "title", "description", "align", "showLabels", "mainButton", "alternativeButton", "feedback", "meliContext", "sectionMetadata", "recaptcha", "privacyConfig", "leadConfiguration", "requestMetadata", "formType"];




































// Andes












var SUBMIT_FORM = framework_namespaceObject.TRACKING_TRIGGERS.SUBMIT_FORM;
var logger = external_frontend_logger_default()('calm-form');
var restClient = external_frontend_restclient_default()({
  timeout: 5000
});
var StructuredForm_namespace = FORM_NAMESPACE;

/**
 * Component
 */
var StructuredForm = function StructuredForm(_ref) {
  var _feedback$success$ass, _feedback$error$asset, _feedback$error, _feedback$error2, _feedback$error3;
  var className = _ref.className,
    isMobile = _ref.isMobile,
    title = _ref.title,
    description = _ref.description,
    align = _ref.align,
    showLabels = _ref.showLabels,
    mainButton = _ref.mainButton,
    alternativeButton = _ref.alternativeButton,
    feedback = _ref.feedback,
    meliContext = _ref.meliContext,
    sectionMetadata = _ref.sectionMetadata,
    recaptcha = _ref.recaptcha,
    privacyConfig = _ref.privacyConfig,
    leadConfiguration = _ref.leadConfiguration,
    requestMetadata = _ref.requestMetadata,
    formType = _ref.formType,
    otherProps = objectWithoutProperties_default()(_ref, StructuredForm_excluded);
  // backward compatibility with the legacy version structure
  var _ref2 = leadConfiguration || otherProps,
    _ref2$customProps = _ref2.customProps,
    customProps = _ref2$customProps === void 0 ? {} : _ref2$customProps,
    fields = _ref2.fields,
    request = _ref2.request,
    language = _ref2.language;
  var _useState = (0,external_react_namespaceObject.useState)(false),
    _useState2 = slicedToArray_default()(_useState, 2),
    showSpinner = _useState2[0],
    setShowSpinner = _useState2[1];
  var _useState3 = (0,external_react_namespaceObject.useState)(FORM_STEPS.UNFILLED),
    _useState4 = slicedToArray_default()(_useState3, 2),
    step = _useState4[0],
    setStep = _useState4[1];
  var _useForm = (0,external_react_hook_form_namespaceObject.useForm)(),
    register = _useForm.register,
    handleSubmit = _useForm.handleSubmit,
    getValues = _useForm.getValues,
    setValue = _useForm.setValue,
    formState = _useForm.formState,
    control = _useForm.control,
    reset = _useForm.reset,
    unregister = _useForm.unregister;
  var errors = formState.errors;
  var privacyField = createPrivacyField(privacyConfig, language);
  var useLabels = isMobile && showLabels.mobile || !isMobile && showLabels.desktop;
  var trackingHandler = (0,framework_namespaceObject.useTracking)();
  var trackClick = (0,framework_namespaceObject.getDefaultEventTrackingFn)(trackingHandler);
  var setCurrentStep = function setCurrentStep(newStep) {
    setStep(newStep);
    setShowSpinner(false);
    reset();
  };
  var generateRecaptchaToken = /*#__PURE__*/function () {
    var _ref3 = asyncToGenerator_default()(/*#__PURE__*/regeneratorRuntime_default()().mark(function _callee() {
      return regeneratorRuntime_default()().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              var key = recaptcha.key,
                _recaptcha$action = recaptcha.action,
                action = _recaptcha$action === void 0 ? 'form' : _recaptcha$action;
              try {
                if (typeof grecaptcha === 'undefined') {
                  throw new Error('GRECAPTCHA_NOT_LOADED');
                }

                // eslint-disable-next-line no-undef
                grecaptcha.enterprise.ready(function () {
                  // eslint-disable-next-line no-undef
                  grecaptcha.enterprise.execute(key, {
                    action: action
                  }).then(function (token) {
                    return resolve({
                      token: token,
                      siteKey: key
                    });
                  })["catch"](reject);
                });
              } catch (error) {
                reject();
              }
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function generateRecaptchaToken() {
      return _ref3.apply(this, arguments);
    };
  }();
  var submitForm = function submitForm(data) {
    var additionalData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var paramsString;
    var domain = request.domain,
      path = request.path,
      queryParams = request.queryParams;
    try {
      paramsString = queryParams ? "?".concat(new URLSearchParams(queryParams).toString()) : '';
    } catch (err) {
      paramsString = '';
    }
    var requestUrl = "https://".concat(domain, "/").concat(path).concat(paramsString);
    var payload = objectSpread2_default()(objectSpread2_default()(objectSpread2_default()({}, customProps), data), additionalData);
    restClient.post(requestUrl, {
      data: payload,
      context: meliContext
    }).then(function (response) {
      logger.info(response);
      setCurrentStep(FORM_STEPS.SUCCESS);
    })["catch"](function (error) {
      var _error$config;
      logger.error((error === null || error === void 0 ? void 0 : error.stack) || 'Fail to post data.', {
        code: (error === null || error === void 0 ? void 0 : error.code) || '',
        data: (error === null || error === void 0 || (_error$config = error.config) === null || _error$config === void 0 ? void 0 : _error$config.data) || '',
        baseUrl: (error === null || error === void 0 ? void 0 : error.baseURL) || '',
        requestUrl: requestUrl || ''
      });
      setCurrentStep(FORM_STEPS.ERROR);
    });
  };
  var customRecaptchaOnSubmit = function customRecaptchaOnSubmit(data, additionalData) {
    var evaluator = recaptcha.evaluator;
    restClient.post(evaluator, {
      data: additionalData,
      context: meliContext
    }).then(function (response) {
      if (response.data.valid) {
        submitForm(data);
      } else {
        setCurrentStep(FORM_STEPS.ERROR);
      }
    })["catch"](function () {
      setCurrentStep(FORM_STEPS.ERROR);
    });
  };
  var onSubmit = /*#__PURE__*/function () {
    var _ref4 = asyncToGenerator_default()(/*#__PURE__*/regeneratorRuntime_default()().mark(function _callee2(data) {
      var filterData, trackdata, _ref5, key, additionalData, _yield$generateRecapt, token, siteKey;
      return regeneratorRuntime_default()().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setShowSpinner(true);
            _context2.prev = 1;
            filterData = cleanFormattedInputs(data);
            if (trackingHandler) {
              trackdata = (0,framework_namespaceObject.buildTracks)(mainButton === null || mainButton === void 0 ? void 0 : mainButton.trackdata, SUBMIT_FORM, sectionMetadata);
              trackClick({}, trackdata);
            }
            _ref5 = recaptcha || {}, key = _ref5.key;
            additionalData = {};
            if (!key) {
              _context2.next = 13;
              break;
            }
            _context2.next = 9;
            return generateRecaptchaToken();
          case 9:
            _yield$generateRecapt = _context2.sent;
            token = _yield$generateRecapt.token;
            siteKey = _yield$generateRecapt.siteKey;
            additionalData = {
              token: token,
              siteKey: siteKey
            };
          case 13:
            if (formType === 'preset') {
              additionalData = objectSpread2_default()(objectSpread2_default()({}, additionalData), requestMetadata);
            }
            if (recaptcha !== null && recaptcha !== void 0 && recaptcha.evaluator) {
              customRecaptchaOnSubmit(data, additionalData);
            } else {
              submitForm(filterData, additionalData);
            }
            _context2.next = 20;
            break;
          case 17:
            _context2.prev = 17;
            _context2.t0 = _context2["catch"](1);
            setCurrentStep(FORM_STEPS.ERROR);
          case 20:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 17]]);
    }));
    return function onSubmit(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  var resetForm = function resetForm() {
    setCurrentStep(FORM_STEPS.UNFILLED);
  };
  var getButtonConfig = function getButtonConfig(button, isSubmit) {
    if (!(button !== null && button !== void 0 && button.title)) {
      return null;
    }
    var buttonProps = button;
    buttonProps = objectSpread2_default()(objectSpread2_default()({}, buttonProps), {}, {
      fullWidth: buttonProps.fullWidth || isMobile,
      onClick: isSubmit ? handleSubmit(onSubmit) : resetForm
    });
    return buttonProps;
  };
  var mainButtonConfig = (0,external_react_namespaceObject.useMemo)(function () {
    return getButtonConfig(mainButton, true);
  }, [mainButton]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var alternativeButtonConfig = (0,external_react_namespaceObject.useMemo)(function () {
    return getButtonConfig(alternativeButton, false);
  }, [alternativeButton]);

  // Clean up fields from Form's state whose name changed (Admin)
  (0,external_react_namespaceObject.useEffect)(function () {
    var dataKeys = Object.keys(getValues());
    var fieldKeys = fields === null || fields === void 0 ? void 0 : fields.map(function (field) {
      return field.name;
    });
    var keysToRemove = dataKeys.filter(function (key) {
      return !fieldKeys.includes(key.replace(FORMATTED_INPUT_SUFFIX, ''));
    });
    keysToRemove.forEach(function (key) {
      return unregister(key);
    });
  }, [fields, getValues, unregister]);
  if (!(fields !== null && fields !== void 0 && fields.length)) {
    return null;
  }
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
    children: [/*#__PURE__*/jsx_default()("div", {
      className: external_classnames_default()(className, StructuredForm_namespace, "".concat(StructuredForm_namespace).concat(isMobile ? '--mobile' : '--desktop'), 'andes-landings-typography', 'andes-landings-typography--type-body', 'andes-landings-typography--size-m')
    }, void 0, showSpinner && /*#__PURE__*/jsx_default()((progress_indicator_circular_default()), {
      modifier: "block",
      size: "small",
      show: showSpinner,
      testid: "spinner",
      srLabel: "Cargando",
      className: "".concat(StructuredForm_namespace, "__loading")
    }, "spinner"), step === FORM_STEPS.SUCCESS && /*#__PURE__*/(0,external_react_namespaceObject.createElement)(src_Feedback, objectSpread2_default()(objectSpread2_default()({}, feedback.success), {}, {
      isMobile: isMobile,
      asset: {
        icon: {
          name: constants_FEEDBACK_SUCCESS
        },
        image: objectSpread2_default()({}, (_feedback$success$ass = feedback.success.asset) === null || _feedback$success$ass === void 0 ? void 0 : _feedback$success$ass.image)
      },
      key: "feedback-success",
      className: "".concat(StructuredForm_namespace, "__feedback ").concat(StructuredForm_namespace, "__feedback--success"),
      sectionMetadata: sectionMetadata
    })), step === FORM_STEPS.ERROR && /*#__PURE__*/(0,external_react_namespaceObject.createElement)(src_Feedback, objectSpread2_default()(objectSpread2_default()({}, feedback.error), {}, {
      isMobile: isMobile,
      asset: {
        icon: {
          name: FEEDBACK_ERROR
        },
        image: objectSpread2_default()({}, (_feedback$error$asset = feedback.error.asset) === null || _feedback$error$asset === void 0 ? void 0 : _feedback$error$asset.image)
      },
      button: {
        onClick: resetForm,
        text: (_feedback$error = feedback.error) === null || _feedback$error === void 0 || (_feedback$error = _feedback$error.button) === null || _feedback$error === void 0 ? void 0 : _feedback$error.text,
        href: (_feedback$error2 = feedback.error) === null || _feedback$error2 === void 0 || (_feedback$error2 = _feedback$error2.button) === null || _feedback$error2 === void 0 ? void 0 : _feedback$error2.href,
        target: ((_feedback$error3 = feedback.error) === null || _feedback$error3 === void 0 || (_feedback$error3 = _feedback$error3.button) === null || _feedback$error3 === void 0 ? void 0 : _feedback$error3.target) || '_self',
        type: 'secondary'
      },
      key: "feedback-error",
      className: "".concat(StructuredForm_namespace, "__feedback ").concat(StructuredForm_namespace, "__feedback--error"),
      sectionMetadata: sectionMetadata
    })), step === FORM_STEPS.UNFILLED && /*#__PURE__*/jsx_default()("div", {
      className: "".concat(StructuredForm_namespace, "__container")
    }, void 0, (title || description) && /*#__PURE__*/jsx_default()("div", {
      className: "".concat(StructuredForm_namespace, "__header")
    }, void 0, /*#__PURE__*/jsx_default()(typography_namespaceObject.Typography, {
      className: external_classnames_default()("".concat(StructuredForm_namespace, "__title")),
      component: "h2",
      type: "title",
      size: "m"
    }, "main-title", title), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(typography_namespaceObject.Typography, objectSpread2_default()({
      className: external_classnames_default()("".concat(StructuredForm_namespace, "__description")),
      type: "body",
      size: "m",
      component: hasParagraphTag(description) ? 'div' : 'p'
    }, getTypographyPropsForALGenericText(description)))), /*#__PURE__*/jsx_default()("form", {
      className: external_classnames_default()("".concat(StructuredForm_namespace, "__form"), !useLabels && "".concat(StructuredForm_namespace, "__form--no-labels"), "".concat(StructuredForm_namespace, "__form--").concat(align))
    }, StructuredForm_namespace, /*#__PURE__*/jsx_default()("fieldset", {
      className: "".concat(StructuredForm_namespace, "__fieldset")
    }, void 0, renderFields(fields, privacyField, errors, {
      registerFn: register,
      getValues: getValues,
      setValue: setValue,
      control: control
    })), /*#__PURE__*/jsx_default()("div", {
      className: "".concat(StructuredForm_namespace, "__actions")
    }, void 0, ((mainButton === null || mainButton === void 0 ? void 0 : mainButton.title) || (alternativeButton === null || alternativeButton === void 0 ? void 0 : alternativeButton.title)) && /*#__PURE__*/jsx_default()(actions_namespaceObject.Actions, {
      primary: mainButtonConfig
      // FIXME: Enable when solving issue with reset
      // secondary={alternativeButtonConfig}
    }))))), /*#__PURE__*/jsx_default()(src_Grecaptcha, {
      config: recaptcha
    })]
  });
};
StructuredForm.defaultProps = {
  description: null,
  align: 'default',
  recaptcha: {},
  showLabels: {
    desktop: true,
    mobile: true
  },
  alternativeButton: null,
  meliContext: {},
  formType: 'custom',
  requestMetadata: {}
};
/* harmony default export */ const src_StructuredForm = (StructuredForm);
;// external "core-js/modules/es.array.unshift.js"
const es_array_unshift_js_namespaceObject = require("core-js/modules/es.array.unshift.js");
;// ./components/molecules/valueProps/src/ValueProps.js






















var ValueProps_namespace = 'pog-ui-value-props';
var VALUE_PROP_SANITIZATION_CONFIG = {
  allowedTags: ['strong']
};

/**
 * Component
 */
var ValueProps = function ValueProps(_ref) {
  var className = _ref.className,
    isMobile = _ref.isMobile,
    oldTitleProp = _ref.title,
    oldDescriptionProp = _ref.description,
    accent = _ref.accent,
    head = _ref.head,
    items = _ref.items,
    columns = _ref.columns,
    inverted = _ref.inverted;
  var filteredItems = items === null || items === void 0 ? void 0 : items.filter(function (item) {
    return item.title;
  });
  var validatedItems = (filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.length) > 0;
  var hasAccent = !!(accent !== null && accent !== void 0 && accent.title);
  var headConfig = {
    title: (head === null || head === void 0 ? void 0 : head.title) || oldTitleProp || undefined,
    description: (head === null || head === void 0 ? void 0 : head.description) || oldDescriptionProp || undefined
  };
  var component = (filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.map(function (item) {
    var _item$icon;
    return item && /*#__PURE__*/(0,external_react_namespaceObject.createElement)(bullets_namespaceObject.BulletsItem, objectSpread2_default()(objectSpread2_default()({}, item), {}, {
      key: item.title.toLowerCase().substring(0, 20).split(' ').join(''),
      className: external_classnames_default()("".concat(ValueProps_namespace, "__item cols-").concat(columns)),
      type: "body",
      size: "m",
      title: null,
      description: getTypographyPropsForALGenericText(item.title, VALUE_PROP_SANITIZATION_CONFIG).children,
      thumb: ((_item$icon = item.icon) === null || _item$icon === void 0 ? void 0 : _item$icon.name) && /*#__PURE__*/jsx_default()(src_Icon, {
        name: item.icon.name,
        options: item.icon.options || {},
        inverted: inverted
      })
    }));
  })) || [];
  if (hasAccent) {
    var _accent$icon;
    component.unshift(/*#__PURE__*/jsx_default()(bullets_namespaceObject.BulletsItem, {
      className: external_classnames_default()("".concat(ValueProps_namespace, "__accent cols-").concat(columns, " ").concat(validatedItems ? 'borderline' : '')),
      type: "title",
      size: "xs",
      title: accent.title,
      thumb: ((_accent$icon = accent.icon) === null || _accent$icon === void 0 ? void 0 : _accent$icon.name) && /*#__PURE__*/jsx_default()(src_Icon, {
        name: accent.icon.name,
        options: accent.icon.options || {},
        inverted: inverted
      })
    }, "main-bullet"));
  }
  return /*#__PURE__*/jsx_default()("div", {
    className: external_classnames_default()(ValueProps_namespace, className, "".concat(ValueProps_namespace, "--").concat(isMobile ? 'mobile' : 'desktop'))
  }, void 0, !hasAccent && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
    children: [headConfig.title && columns === 1 && /*#__PURE__*/jsx_default()("div", {
      className: "".concat(ValueProps_namespace, "__container-secondary-title cols-").concat(columns)
    }, void 0, /*#__PURE__*/jsx_default()(typography_namespaceObject.Typography, {
      className: "".concat(ValueProps_namespace, "__title"),
      color: inverted ? 'inverted' : 'primary',
      type: "title",
      size: "m"
    }, void 0, headConfig.title), headConfig.description && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(typography_namespaceObject.Typography, objectSpread2_default()({
      className: "".concat(ValueProps_namespace, "__description"),
      color: inverted ? 'inverted' : 'primary',
      type: "body",
      size: "l"
    }, getTypographyPropsForALGenericText(headConfig.description)))), /*#__PURE__*/jsx_default()(bullets_namespaceObject.Bullets, {
      className: external_classnames_default()("".concat(ValueProps_namespace, "__items cols-").concat(columns)),
      inverted: inverted
    }, void 0, component)]
  }), hasAccent && /*#__PURE__*/jsx_default()(bullets_namespaceObject.Bullets, {
    className: "".concat(ValueProps_namespace, "__accent-container ").concat(ValueProps_namespace, "__items cols-").concat(columns),
    inverted: inverted
  }, void 0, component));
};

/**
 * PropTypes
 */

ValueProps.defaultProps = {
  isMobile: false,
  title: '',
  description: '',
  items: null,
  accent: null,
  main: null,
  columns: 1,
  inverted: false
};

/**
 * Export ValueProps
 */

/* harmony default export */ const src_ValueProps = (ValueProps);
;// ./utils/constants/colorThemes.js

var colorThemes_DARK_FONT_THEMES = ['primary-grey-solid'];
var colorThemes_LIGHT_FONT_THEMES = ['primary-blue-solid', 'primary-blue-gradient', 'primary-dark-blue-gradient', 'primary-light-blue-gradient', 'secondary-blue-gradient', 'secondary-dark-blue-gradient', 'dark-blue-gradient', 'dark-gradient'];
var colorThemes_COLOR_THEMES = [].concat(colorThemes_DARK_FONT_THEMES, colorThemes_LIGHT_FONT_THEMES);
;// ./utils/constants/colorToALThemes.js
var COLOR_AVAILABLE_VALUES = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary'
};
;// ./utils/src/backgroundHelpers.js











var POG_UI_LANDINGS_BG_NAMESPACE = 'pog-ui-container__bg';
var isValidTheme = function isValidTheme(theme) {
  return theme && COLOR_THEMES.includes(theme);
};
var isDarkFontTheme = function isDarkFontTheme(theme) {
  return isValidTheme(theme) && DARK_FONT_THEMES.includes(theme);
};
var isLightFontTheme = function isLightFontTheme(theme) {
  return isValidTheme(theme) && LIGHT_FONT_THEMES.includes(theme);
};
var getThemeClass = function getThemeClass(theme) {
  return isValidTheme(theme) ? "".concat(POG_UI_LANDINGS_BG_NAMESPACE, "-").concat(theme) : '';
};
var getConcaveObject = function getConcaveObject(concaveProps) {
  if (typeof concaveProps === 'boolean') {
    return {
      top: concaveProps,
      bottom: concaveProps
    };
  }
  if (_typeof(concaveProps) === 'object' && (concaveProps !== null && concaveProps !== void 0 && concaveProps.top || concaveProps !== null && concaveProps !== void 0 && concaveProps.bottom)) {
    return {
      top: concaveProps.top,
      bottom: concaveProps.bottom
    };
  }
  return {
    top: false,
    bottom: false
  };
};
var setPaddings = function setPaddings(paddings, isMobile) {
  var _paddings$mobile, _paddings$desktop, _paddings$mobile2, _paddings$desktop2;
  var paddingTop = isMobile ? paddings === null || paddings === void 0 || (_paddings$mobile = paddings.mobile) === null || _paddings$mobile === void 0 ? void 0 : _paddings$mobile.top : paddings === null || paddings === void 0 || (_paddings$desktop = paddings.desktop) === null || _paddings$desktop === void 0 ? void 0 : _paddings$desktop.top;
  var paddingBottom = isMobile ? paddings === null || paddings === void 0 || (_paddings$mobile2 = paddings.mobile) === null || _paddings$mobile2 === void 0 ? void 0 : _paddings$mobile2.bottom : paddings === null || paddings === void 0 || (_paddings$desktop2 = paddings.desktop) === null || _paddings$desktop2 === void 0 ? void 0 : _paddings$desktop2.bottom;
  return {
    paddingTop: paddingTop,
    paddingBottom: paddingBottom
  };
};
var getBackgroundOptions = function getBackgroundOptions(background) {
  var _ref = background || {},
    theme = _ref.theme,
    gradient = _ref.gradient,
    color = _ref.color,
    _ref$concave = _ref.concave,
    concave = _ref$concave === void 0 ? false : _ref$concave,
    darkFont = _ref.darkFont;
  var options = {
    processed: true,
    theme: isValidTheme(theme) ? theme : null,
    color: color,
    gradient: gradient,
    concave: getConcaveObject(concave),
    darkFont: null
  };

  // Theme defined colors
  if (isDarkFontTheme(options.theme)) {
    return _objectSpread(_objectSpread({}, options), {}, {
      darkFont: true
    });
  }
  if (isLightFontTheme(options.theme)) {
    return _objectSpread(_objectSpread({}, options), {}, {
      darkFont: false
    });
  }

  // User defined
  if (!options.theme && isBoolean(darkFont)) {
    return _objectSpread(_objectSpread({}, options), {}, {
      darkFont: darkFont
    });
  }

  // Set Default value when neither a valid theme, nor a custom color/gradient set.
  return _objectSpread(_objectSpread({}, options), {}, {
    darkFont: !isValidTheme(options.theme) && !gradient && !color
  });
};
var getALBackgroundOptions = function getALBackgroundOptions(background, isMobile, andesTheme) {
  var isRebranding = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var hasBackground = !(0,external_lodash_namespaceObject.isNil)(background === null || background === void 0 ? void 0 : background.type);
  var theme = hasBackground && (background === null || background === void 0 ? void 0 : background.type) === 'hero' && !(0,external_lodash_namespaceObject.isNil)(background === null || background === void 0 ? void 0 : background.theme) ? background === null || background === void 0 ? void 0 : background.theme : null;

  // FIXME: AL has not defined how they're going to support a third theme. We keep the change focused on Heros' dark theme
  if (theme === 'dark') {
    // Dark theme uses light font as the default one, so we prevent inverted styles to interfere.
    background.inverted = false;
    background.theme = theme;
  } else if (hasBackground && theme) {
    background.theme = null;
  }
  var paddingStyles = background !== null && background !== void 0 && background.paddings ? setPaddings(background.paddings, isMobile) : null;
  var options = objectSpread2_default()(objectSpread2_default()({}, background), {}, {
    // By now we will just allow div components
    component: 'div',
    paddings: paddingStyles,
    curves: isRebranding && (background === null || background === void 0 ? void 0 : background.type) !== 'hero' ? 0 : background === null || background === void 0 ? void 0 : background.curves
  });
  var defaultsToDarkFont = !background || background.darkFont === true || !hasBackground || background.inverted || (andesTheme === themes.THEMES.ML || andesTheme === themes.THEMES.MP && isRebranding) && (background === null || background === void 0 ? void 0 : background.type) === 'hero' && theme !== 'dark';
  if (defaultsToDarkFont) {
    options.darkFont = true;
  }
  var defaultsToLightFont = hasBackground && (0,external_lodash_namespaceObject.isNil)(options.darkFont) && !background.inverted;
  if (defaultsToLightFont) {
    options.darkFont = false;
  }
  return options;
};
var getALBackgroundOptionsFromColor = function getALBackgroundOptionsFromColor(background, isMobile, andesTheme) {
  var isRebranding = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  // If color is not defined, fallbacks to previous definition
  if ((0,external_lodash_namespaceObject.isNil)(background === null || background === void 0 ? void 0 : background.color)) {
    return getALBackgroundOptions(background, isMobile, andesTheme, isRebranding);
  }
  var backgroundClone = (0,external_lodash_namespaceObject.cloneDeep)(background);
  var color = backgroundClone.color,
    curves = backgroundClone.curves,
    type = backgroundClone.type;

  // Fallback for curves (RJSF Forms store a -1 rather than a 0)
  if (curves < 1) {
    backgroundClone.curves = 0;
  }

  // Fallback color for unexepected values
  if (!Object.values(COLOR_AVAILABLE_VALUES).includes(color) || type !== 'hero' && color === COLOR_AVAILABLE_VALUES.TERTIARY) {
    backgroundClone.color = null;
  }
  switch (backgroundClone.color) {
    case COLOR_AVAILABLE_VALUES.PRIMARY:
      backgroundClone.inverted = false;
      backgroundClone.darkFont = andesTheme !== themes.THEMES.MP && type === 'hero' || andesTheme === themes.THEMES.MP && isRebranding && type === 'hero';
      backgroundClone.theme = null;
      break;
    case COLOR_AVAILABLE_VALUES.SECONDARY:
      backgroundClone.inverted = true;
      backgroundClone.darkFont = true;
      backgroundClone.theme = null;
      break;
    case COLOR_AVAILABLE_VALUES.TERTIARY:
      backgroundClone.inverted = false;
      backgroundClone.darkFont = false;
      backgroundClone.theme = 'dark';
      break;
    default:
      break;
  }
  return getALBackgroundOptions(backgroundClone, isMobile, andesTheme, isRebranding);
};
;// ./utils/src/dataAttributesHelpers.js










var normalizeDataAttributesConfig = function normalizeDataAttributesConfig(config) {
  if (!config) {
    return null;
  }
  if (!config.dataAttributes) {
    return objectSpread2_default()({}, config);
  }
  var clone = objectSpread2_default()({}, config);
  var dataAttributes = clone.dataAttributes;
  if (dataAttributes) {
    var dataProps = Object.keys(dataAttributes).reduce(function (accumulator, key) {
      return objectSpread2_default()(objectSpread2_default()({}, accumulator), {}, defineProperty_default()({}, "data-".concat(key), dataAttributes[key]));
    }, {});
    var normalizedConfig = objectSpread2_default()(objectSpread2_default()({}, clone), dataProps);
    delete normalizedConfig.dataAttributes;
    return normalizedConfig;
  }
  return clone;
};
var bulkNormalizeDataAttributesConfig = function bulkNormalizeDataAttributesConfig(obj) {
  var normalizedConfigs;
  for (var _len = arguments.length, configs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    configs[_key - 1] = arguments[_key];
  }
  configs.forEach(function (config) {
    normalizedConfigs = objectSpread2_default()(objectSpread2_default()({}, normalizedConfigs), {}, defineProperty_default()({}, config, obj ? normalizeDataAttributesConfig(obj[config]) : null));
  });
  return normalizedConfigs;
};
;// ./components/hooks/useOnScreen.js


var useOnScreen = function useOnScreen(ref) {
  var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var _useState = (0,external_react_namespaceObject.useState)(false),
    _useState2 = slicedToArray_default()(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  var observer = (0,external_react_namespaceObject.useMemo)(function () {
    if (typeof IntersectionObserver !== 'function') {
      setIsVisible(false);
      return null;
    }
    return new IntersectionObserver(function (_ref) {
      var _ref2 = slicedToArray_default()(_ref, 1),
        entry = _ref2[0];
      setIsVisible(entry.isIntersecting);
    }, {
      threshold: threshold
    });
  }, [ref]);
  (0,external_react_namespaceObject.useEffect)(function () {
    if (observer) {
      if (ref !== null && ref !== void 0 && ref.current) {
        observer.observe(ref.current);
      }
    }
    return function () {
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);
  return {
    isVisible: isVisible,
    observer: observer
  };
};
;// ./components/hooks/useTrackShow.js





var useTrackShow = function useTrackShow(refModule, tracking, sectionMetadata) {
  var requireDispatchCall = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var _ref = tracking || {},
    onShow = _ref.onShow;
  var refElement = onShow !== null && onShow !== void 0 && onShow.enabled ? refModule : null;
  var customThreshold = Number(onShow === null || onShow === void 0 ? void 0 : onShow.threshold);
  var threshold = 0.9;
  if (!Number.isNaN(customThreshold) && customThreshold >= 0.0 && customThreshold <= 1.0) {
    threshold = customThreshold;
  }
  var trackingHandler = (0,framework_namespaceObject.useTracking)();
  var trackShow = (0,framework_namespaceObject.getShowTrackingFn)(trackingHandler);
  var _useOnScreen = useOnScreen(refElement, threshold),
    isVisible = _useOnScreen.isVisible,
    observer = _useOnScreen.observer;
  (0,external_react_namespaceObject.useEffect)(function () {
    if (isVisible) {
      trackShow(sectionMetadata);
      if (observer) {
        observer.disconnect();
      }
    }
  }, [isVisible]);
  if (requireDispatchCall) {
    var sendTrackShow = function sendTrackShow(data) {
      trackShow(data);
    };
    return {
      isVisible: isVisible,
      sendTrackShow: sendTrackShow
    };
  }
  return {
    isVisible: isVisible
  };
};
/* harmony default export */ const hooks_useTrackShow = (useTrackShow);
;// ./components/sections/heroSection/src/constants/index.js
var MAX_TEXT_LENGTH = 38;
var MAX_TEXT_LENGTH_WITH_STRONG = MAX_TEXT_LENGTH + 17; // <strong></strong> has 17 additional characters

var AL_HERO_TITLE_MIXED_SANITIZATION_CONFIG = {
  allowedTags: ['strong']
};
var AL_HERO_TITLE_DEFAULT_SANITIZATION_CONFIG = {
  allowedTags: []
};
var AL_HERO_VOLANTA_PILL_SANITIZATION_CONFIG = {
  allowedTags: []
};
var AL_HERO_DESCRIPTION_SANITIZATION_CONFIG = {
  allowedTags: ['strong']
};
var VOLANTA_SIZES = {
  S: 's',
  M: 'm'
};
var TITLE_SIZES = {
  S: 's',
  M: 'm',
  L: 'l'
};
var DESCRIPTION_SIZES = {
  L: 'l',
  XL: 'xl'
};
;// ./components/sections/heroSection/src/constants/layout.js
var GRID_COLS_PRIMARY_BLOCK = {
  2: 6,
  3: 4
};
var GRID_COLS_SECONDARY_BLOCK = {
  2: 6,
  3: 4
};
var GRID_COLS_TERTIARY_BLOCK = {
  2: 0,
  3: 4
};
var GRID_FULL_WIDTH = 12;
;// ./utils/src/titleHelpers.js


var titleHelpers_AL_VOLANTA_SANITIZATION_CONFIG = GENERAL_SANITIZATION_RULES.AL_VOLANTA_SANITIZATION_CONFIG,
  titleHelpers_AL_DESCRIPTION_SANITIZATION_CONFIG = GENERAL_SANITIZATION_RULES.AL_DESCRIPTION_SANITIZATION_CONFIG;
var getTypographyPropsForALVolanta = function getTypographyPropsForALVolanta(volanta, customSanitizationConfig) {
  return getTypographyPropsForHtmlContent(volanta, true, customSanitizationConfig || titleHelpers_AL_VOLANTA_SANITIZATION_CONFIG);
};
var getTypographyPropsForALDescription = function getTypographyPropsForALDescription(description, customSanitizationConfig) {
  var descriptionAsObject = getTypographyPropsForHtmlContent(description, true, customSanitizationConfig || titleHelpers_AL_DESCRIPTION_SANITIZATION_CONFIG);
  if (hasParagraphTag(descriptionAsObject === null || descriptionAsObject === void 0 ? void 0 : descriptionAsObject.children)) {
    descriptionAsObject.component = 'div';
  }
  return descriptionAsObject;
};
;// ./components/sections/heroSection/src/utils/headHelpers.js





var getTypographyPropsForALTitle = function getTypographyPropsForALTitle(title, mixed) {
  return getTypographyPropsForHtmlContent(title, true, mixed ? AL_HERO_TITLE_MIXED_SANITIZATION_CONFIG : AL_HERO_TITLE_DEFAULT_SANITIZATION_CONFIG);
};
var isPlainString = function isPlainString(headElement) {
  return typeof headElement === 'string';
};
var getVolantaSize = function getVolantaSize(isRebrand, titleSize) {
  if (!isRebrand) {
    return VOLANTA_SIZES.S;
  }
  return [TITLE_SIZES.M, TITLE_SIZES.L].includes(titleSize) ? VOLANTA_SIZES.M : VOLANTA_SIZES.S;
};
var getDescriptionSize = function getDescriptionSize(isRebrand, titleSize) {
  if (!isRebrand) {
    return DESCRIPTION_SIZES.L;
  }
  return [TITLE_SIZES.M, TITLE_SIZES.L].includes(titleSize) ? DESCRIPTION_SIZES.XL : DESCRIPTION_SIZES.L;
};
var getALHeadDescriptionProps = function getALHeadDescriptionProps(description, isRebrand) {
  var titleSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : TITLE_SIZES.S;
  // Current implementation: Supports string definitions, casted to object to include contentHtml property
  if (isPlainString(description)) {
    return objectSpread2_default()(objectSpread2_default()({}, getTypographyPropsForALDescription(description, AL_HERO_DESCRIPTION_SANITIZATION_CONFIG)), {}, {
      size: titleSize === TITLE_SIZES.S ? DESCRIPTION_SIZES.L : getDescriptionSize(isRebrand, titleSize)
    });
  }
  return objectSpread2_default()(objectSpread2_default()(objectSpread2_default()({}, description), getTypographyPropsForALDescription(description === null || description === void 0 ? void 0 : description.children, AL_HERO_DESCRIPTION_SANITIZATION_CONFIG)), {}, {
    size: isRebrand ? getDescriptionSize(isRebrand, titleSize) : DESCRIPTION_SIZES.L
  });
};
var getALHeadTitleProps = function getALHeadTitleProps(title, isRebrand, mixed) {
  // Use string definition, casted to object to include contentHtml property if mixed is set
  if (isPlainString(title)) {
    return mixed ? getTypographyPropsForALTitle(title, true) : title;
  }

  // Receives object, ensures contentHtml and sanitization (called on title.children)
  // If rebranding is on, ensure it propagates size
  return objectSpread2_default()(objectSpread2_default()(objectSpread2_default()({}, title), getTypographyPropsForALTitle(title === null || title === void 0 ? void 0 : title.children, mixed)), {}, {
    size: isRebrand && title !== null && title !== void 0 && title.size ? title === null || title === void 0 ? void 0 : title.size : TITLE_SIZES.S
  });
};
var getALHeadVolantaProps = function getALHeadVolantaProps(volanta, isRebrand) {
  var titleSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : TITLE_SIZES.S;
  var isPill = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var isString = isPlainString(volanta);
  var content = isString ? volanta : volanta === null || volanta === void 0 ? void 0 : volanta.children;
  var volantaProps = getTypographyPropsForALVolanta(content, isPill ? AL_HERO_VOLANTA_PILL_SANITIZATION_CONFIG : null);

  // Current implementation: Supports string definitions, casted to object to include contentHtml property
  if (!isRebrand) {
    return volantaProps;
  }

  // Receives object, ensures contentHtml and sanitization (called on title.children)
  // If rebranding is on, size will depend from title.size
  return objectSpread2_default()(objectSpread2_default()(objectSpread2_default()({}, volanta), volantaProps), {}, {
    size: getVolantaSize(isRebrand, titleSize)
  });
};
;// ./components/contexts/tracking/src/constants.js
var LEXICAL_LINK_CLASS = 'lexical-link';
var LEXICAL_LINK_TEXT_LIMIT = 100;
var MELIDATA_MODE_SEND = 'send';
var MELIDATA_MODE_CLEAN_SEND = 'cleanAndSend';
var TRACKING_TRIGGERS = {
  BRAND: 'brand',
  BUTTON_ALTERNATIVE: 'button alternative',
  BUTTON_ERROR: 'button error',
  BUTTON_PRIMARY: 'button primary',
  BUTTON_SUCCESS: 'button success',
  CARD_LINK: 'card link',
  FAQ: 'FAQ',
  HOME_LINK: 'home link',
  HYPERLINK: 'hyperlink',
  SLIDE: 'slide',
  SHORTCUT: 'shortcut',
  SUBMIT_ERROR: 'submit error',
  SUBMIT_FORM: 'submit form',
  SUBMIT_SUCCESS: 'submit success',
  VIDEO: 'play video'
};
;// ./components/hooks/useTrackRichText.js












var useTrackRichText = function useTrackRichText(refModule, sectionMetadata) {
  var _useState = (0,external_react_namespaceObject.useState)(0),
    _useState2 = slicedToArray_default()(_useState, 2),
    countHyperlink = _useState2[0],
    setCountHyperlink = _useState2[1];
  var trackingHandler = (0,framework_namespaceObject.useTracking)();
  var trackClick = (0,framework_namespaceObject.getDefaultEventTrackingFn)(trackingHandler);
  var handlerTrack = function handlerTrack(e) {
    var textContent = e.target.text || e.target.innerHTML || '';
    var formattedText = textContent.substring(0, LEXICAL_LINK_TEXT_LIMIT).concat(textContent.length > LEXICAL_LINK_TEXT_LIMIT ? '...' : '');
    var trackData = (0,framework_namespaceObject.buildTracks)(null, "hyperlink with text: ".concat(formattedText), sectionMetadata);
    trackClick(e, trackData);
  };
  (0,external_react_namespaceObject.useEffect)(function () {
    var allHyperlinks = [];
    if (refModule !== null && refModule !== void 0 && refModule.current) {
      var _allHyperlinks;
      // Get hyperlinks created by lexical
      allHyperlinks = refModule.current.querySelectorAll("a.".concat(LEXICAL_LINK_CLASS));
      if ((_allHyperlinks = allHyperlinks) !== null && _allHyperlinks !== void 0 && _allHyperlinks.length) {
        setCountHyperlink(allHyperlinks.length);
        allHyperlinks.forEach(function (hyperlinkLexical) {
          hyperlinkLexical.addEventListener('click', handlerTrack);
        });
      } else {
        // Call handlerTrack to elements until they appear, e.g: modal section elements
        refModule.current.addEventListener('click', function (e) {
          var _e$target$className = e.target.className,
            className = _e$target$className === void 0 ? null : _e$target$className;
          if (typeof className === 'string' && className.includes(LEXICAL_LINK_CLASS)) {
            handlerTrack(e);
          }
        });
      }
    }
    return function () {
      allHyperlinks.forEach(function (hyperlinkLexical) {
        hyperlinkLexical.removeEventListener('click', handlerTrack);
      });
      if (refModule !== null && refModule !== void 0 && refModule.current) {
        refModule.current.removeEventListener('click', handlerTrack);
      }
    };
  }, [refModule]);
  return {
    countHyperlink: countHyperlink
  };
};
/* harmony default export */ const hooks_useTrackRichText = (useTrackRichText);
;// ./components/sections/heroSection/src/HeroSection.js




var HeroSection_excluded = ["color", "darkFont", "paddings", "type", "theme"];







/* eslint-disable no-nested-ternary */
/**
 * Component dependencies
 */





























var HeroSection_namespace = 'pog-ui-hero-section';

/**
 * HeroSection
 */

var HeroSection = function HeroSection(_ref) {
  var _form$fields, _form$leadConfigurati, _form$leadConfigurati2, _headProps$descriptio, _headProps$volanta, _headProps$volanta2, _valueStatement$thumb, _asset$image;
  var id = _ref.id,
    className = _ref.className,
    isMobile = _ref.isMobile,
    isWebView = _ref.isWebView,
    andesTheme = _ref.andesTheme,
    head = _ref.head,
    asset = _ref.asset,
    columns = _ref.columns,
    background = _ref.background,
    margins = _ref.margins,
    actions = _ref.actions,
    valueStatement = _ref.valueStatement,
    pricing = _ref.pricing,
    countdown = _ref.countdown,
    valueProps = _ref.valueProps,
    complementaryInformation = _ref.complementaryInformation,
    form = _ref.form,
    tracking = _ref.tracking,
    sectionMetadata = _ref.sectionMetadata,
    requestMetadata = _ref.requestMetadata;
  var moduleRef = (0,external_react_namespaceObject.useRef)(null);
  hooks_useTrackRichText(moduleRef, sectionMetadata);
  hooks_useTrackShow(moduleRef, tracking, sectionMetadata);
  var _ref2 = (0,framework_namespaceObject.useCalmContext)() || {},
    _ref2$isRebrand = _ref2.isRebrand,
    isRebrand = _ref2$isRebrand === void 0 ? false : _ref2$isRebrand,
    _ref2$keepImageURLs = _ref2.keepImageURLs,
    keepImageURLs = _ref2$keepImageURLs === void 0 ? false : _ref2$keepImageURLs;
  var trackingHandler = (0,framework_namespaceObject.useTracking)();
  var trackClick = (0,framework_namespaceObject.getDefaultEventTrackingFn)(trackingHandler);
  var _ref3 = valueProps || {},
    title = _ref3.title,
    accent = _ref3.accent,
    items = _ref3.items,
    propsHead = _ref3.head;
  var _ref4 = valueStatement || {},
    sameDay = _ref4.sameDay;
  var _ref5 = asset || {},
    _ref5$showImageMobile = _ref5.showImageMobile,
    showImageMobile = _ref5$showImageMobile === void 0 ? true : _ref5$showImageMobile;
  var isThemeMP = andesTheme === themes.THEMES.MP;
  var isLegacyMode = isThemeMP && !isRebrand;
  var hasForm = !!(form !== null && form !== void 0 && (_form$fields = form.fields) !== null && _form$fields !== void 0 && _form$fields.length) || !!(form !== null && form !== void 0 && (_form$leadConfigurati = form.leadConfiguration) !== null && _form$leadConfigurati !== void 0 && (_form$leadConfigurati = _form$leadConfigurati.fields) !== null && _form$leadConfigurati !== void 0 && _form$leadConfigurati.length);
  var shouldShowImage = !isMobile || showImageMobile || !showImageMobile && !hasForm;
  var validatedColumns = propsHead !== null && propsHead !== void 0 && propsHead.title || title ? 3 : (items === null || items === void 0 ? void 0 : items.length) > 0 && !(accent !== null && accent !== void 0 && accent.title) && columns === 3 ? columns : 2;
  var images = getImageProperties(asset === null || asset === void 0 ? void 0 : asset.image, {
    setDefaultSrc: true,
    setSrcSetString: true,
    rewriteURLs: isThemeMP && isRebrand && !keepImageURLs
  });
  var _getALBackgroundOptio = getALBackgroundOptionsFromColor(objectSpread2_default()(objectSpread2_default()({}, background), {}, {
      type: 'hero'
    }), isMobile, andesTheme, isRebrand),
    color = _getALBackgroundOptio.color,
    darkFont = _getALBackgroundOptio.darkFont,
    paddings = _getALBackgroundOptio.paddings,
    type = _getALBackgroundOptio.type,
    theme = _getALBackgroundOptio.theme,
    backgroundOptions = objectWithoutProperties_default()(_getALBackgroundOptio, HeroSection_excluded);
  var _bulkNormalizeDataAtt = bulkNormalizeDataAttributesConfig(actions, 'mainButton', 'alternativeButton'),
    mainButton = _bulkNormalizeDataAtt.mainButton,
    alternativeButton = _bulkNormalizeDataAtt.alternativeButton;
  var getButtonConfig = function getButtonConfig(button) {
    if (!(button !== null && button !== void 0 && button.title)) {
      return null;
    }
    var trackdata = (0,framework_namespaceObject.buildTracks)(button === null || button === void 0 ? void 0 : button.trackdata, button.priority, sectionMetadata);
    var buttonProps = objectSpread2_default()(objectSpread2_default()({}, button), darkFont ? {
      theme: 'blue'
    } : {
      theme: 'white'
    });
    if (button !== null && button !== void 0 && button.href && isWebView) {
      buttonProps = objectSpread2_default()(objectSpread2_default()({}, buttonProps), {}, {
        href: button.webviewHref || button.href
      });
    }
    buttonProps = objectSpread2_default()(objectSpread2_default()({}, buttonProps), {}, {
      onClick: function onClick(ev) {
        trackClick(ev, trackdata);
      }
    });
    return buttonProps;
  };
  var StructuredFormComponent = form !== null && form !== void 0 && form.fields || form !== null && form !== void 0 && (_form$leadConfigurati2 = form.leadConfiguration) !== null && _form$leadConfigurati2 !== void 0 && _form$leadConfigurati2.fields ? /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(src_StructuredForm, objectSpread2_default()(objectSpread2_default()({}, form), {}, {
    className: external_classnames_default()(form.className || '', "".concat(HeroSection_namespace, "__form")),
    isMobile: isMobile,
    sectionMetadata: sectionMetadata,
    requestMetadata: requestMetadata
  })) : null;
  var valuePropsComponent = accent !== null && accent !== void 0 && accent.title || items !== null && items !== void 0 && items.length ? /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(src_ValueProps, objectSpread2_default()(objectSpread2_default()({}, valueProps), {}, {
    className: external_classnames_default()(valueProps.className || '', "".concat(HeroSection_namespace, "__value-props")),
    isMobile: isMobile,
    inverted: !darkFont,
    columns: validatedColumns === 3 || !(valueProps !== null && valueProps !== void 0 && valueProps.columns) ? 1 : valueProps.columns
  })) : null;
  var headProps = null;
  if (head !== null && head !== void 0 && head.title) {
    var titleProps = getALHeadTitleProps(head.title, !isLegacyMode, !isLegacyMode && head.mixed);
    headProps = {
      title: titleProps,
      description: getALHeadDescriptionProps(head.description, !isLegacyMode, titleProps.size),
      volanta: getALHeadVolantaProps(head.volanta, !isLegacyMode, titleProps.size, head.pill)
    };
  }
  return /*#__PURE__*/jsx_default()(src_Spacer, {
    isMobile: isMobile,
    margins: margins
  }, void 0, /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
    id: id,
    ref: moduleRef,
    className: "".concat(HeroSection_namespace, "__container"),
    children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(background_namespaceObject.Background, objectSpread2_default()(objectSpread2_default()({}, backgroundOptions), {}, {
      className: external_classnames_default()(backgroundOptions.className, "".concat(HeroSection_namespace, "__background"), defineProperty_default()(defineProperty_default()({}, "".concat(HeroSection_namespace, "__background--theme-").concat(theme), !!theme), "".concat(HeroSection_namespace, "__background--theme-rebrand"), andesTheme === themes.THEMES.MP && isRebrand && !backgroundOptions.inverted && theme !== 'dark')),
      type: "hero",
      style: paddings,
      children: [/*#__PURE__*/jsx_default()(layout_namespaceObject.Grid, {
        container: true,
        component: "div",
        className: external_classnames_default()(HeroSection_namespace, className, isMobile ? "".concat(HeroSection_namespace, "--mobile") : "".concat(HeroSection_namespace, "--desktop"))
      }, void 0, /*#__PURE__*/jsx_default()(layout_namespaceObject.GridItem, {
        col: isMobile ? GRID_FULL_WIDTH : GRID_COLS_PRIMARY_BLOCK[validatedColumns],
        className: "".concat(HeroSection_namespace, "__primary-block-container")
      }, void 0, (head === null || head === void 0 ? void 0 : head.title) && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(title_namespaceObject.TitleBase, objectSpread2_default()(objectSpread2_default()({}, head), {}, {
        className: external_classnames_default()("".concat(HeroSection_namespace, "__title"), head === null || head === void 0 ? void 0 : head.className, isLegacyMode ? "".concat(HeroSection_namespace, "--title-legacy") : ''),
        title: headProps.title,
        description: (_headProps$descriptio = headProps.description) !== null && _headProps$descriptio !== void 0 && _headProps$descriptio.children ? headProps.description : '',
        volanta: (_headProps$volanta = headProps.volanta) !== null && _headProps$volanta !== void 0 && _headProps$volanta.children ? headProps.volanta : '',
        misc: false,
        align: isMobile ? 'center' : 'left',
        heading: "h1",
        inverted: !darkFont,
        isHero: true,
        pill: !isLegacyMode && head.pill && ((_headProps$volanta2 = headProps.volanta) === null || _headProps$volanta2 === void 0 || (_headProps$volanta2 = _headProps$volanta2.children) === null || _headProps$volanta2 === void 0 ? void 0 : _headProps$volanta2.length),
        mixed: !isLegacyMode && head.mixed
      })), (pricing === null || pricing === void 0 ? void 0 : pricing.currentAmount) && !form && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(src_MoneyAmountBox, objectSpread2_default()(objectSpread2_default()({}, pricing), {}, {
        className: external_classnames_default()("".concat(HeroSection_namespace, "__pricing"), pricing.className),
        isMobile: isMobile,
        currentAmount: pricing.currentAmount,
        inverted: !darkFont
      })), !(!isMobile && validatedColumns === 3) && (countdown === null || countdown === void 0 ? void 0 : countdown.endDate) && !form && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(src_Countdown, objectSpread2_default()(objectSpread2_default()({}, countdown), {}, {
        className: external_classnames_default()("".concat(HeroSection_namespace, "__countdown"), countdown.className),
        isMobile: isMobile,
        endDate: countdown.endDate
      })), complementaryInformation && !form && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(typography_namespaceObject.Typography, objectSpread2_default()({
        className: "".concat(HeroSection_namespace, "__complementary-information"),
        type: "body",
        size: "m",
        color: darkFont ? 'primary' : 'inverted',
        component: hasParagraphTag(complementaryInformation) ? 'div' : 'span'
      }, getTypographyPropsForHtmlContent(complementaryInformation, true))), (mainButton === null || mainButton === void 0 ? void 0 : mainButton.title) && !form && /*#__PURE__*/jsx_default()("div", {
        className: "".concat(HeroSection_namespace, "__actions-container cols-").concat(validatedColumns)
      }, void 0, /*#__PURE__*/jsx_default()(actions_namespaceObject.Actions, {
        primary: getButtonConfig(mainButton),
        secondary: getButtonConfig(alternativeButton),
        className: "".concat(HeroSection_namespace, "__actions-buttons")
      }), valueStatement !== null && valueStatement !== void 0 && valueStatement.text ? (valueStatement === null || valueStatement === void 0 ? void 0 : valueStatement.thumb) && /*#__PURE__*/jsx_default()(bullets_namespaceObject.Bullets, {
        inverted: !darkFont
      }, void 0, /*#__PURE__*/jsx_default()(bullets_namespaceObject.BulletsItem, {
        title: "",
        description: getTypographyPropsForALGenericText(valueStatement.text).children.slice(0, valueStatement.text.includes('<strong') ? MAX_TEXT_LENGTH_WITH_STRONG : MAX_TEXT_LENGTH),
        className: external_classnames_default()("".concat(HeroSection_namespace, "__actions-bullet"), valueStatement.className),
        type: "body",
        size: isMobile ? 'l' : 'm',
        thumb: ((_valueStatement$thumb = valueStatement.thumb) === null || _valueStatement$thumb === void 0 ? void 0 : _valueStatement$thumb.name) && /*#__PURE__*/jsx_default()(src_Icon, {
          name: valueStatement.thumb.name,
          options: valueStatement.thumb.options || {},
          inverted: !darkFont
        })
      })) : (sameDay === null || sameDay === void 0 ? void 0 : sameDay.textVariant) && /*#__PURE__*/jsx_default()(src_SameDay, {
        className: external_classnames_default()("".concat(HeroSection_namespace, "__actions-same-day"), valueStatement.className),
        isMobile: isMobile,
        sameDay: sameDay,
        thumb: valueStatement === null || valueStatement === void 0 ? void 0 : valueStatement.thumb,
        inverted: !darkFont
      })), form && validatedColumns !== 3 && !isMobile && StructuredFormComponent, validatedColumns !== 3 && !!valueProps && (!valueProps.columns || valueProps.columns === 1) && !isMobile && /*#__PURE__*/jsx_default()("div", {
        className: "".concat(HeroSection_namespace, "__value-props-container cols-").concat(validatedColumns)
      }, void 0, valuePropsComponent)), /*#__PURE__*/jsx_default()(layout_namespaceObject.GridItem, {
        col: isMobile ? GRID_FULL_WIDTH : GRID_COLS_SECONDARY_BLOCK[validatedColumns],
        className: "".concat(HeroSection_namespace, "__second-block-container cols-").concat(validatedColumns)
      }, void 0, shouldShowImage && /*#__PURE__*/jsx_default()(image_container_namespaceObject.ImageContainer, {
        img: images,
        className: external_classnames_default()("".concat(HeroSection_namespace, "__image cols-").concat(validatedColumns), (_asset$image = asset.image) === null || _asset$image === void 0 ? void 0 : _asset$image.className)
      }), form && isMobile && StructuredFormComponent), (validatedColumns === 3 || isMobile) && /*#__PURE__*/jsx_default()(layout_namespaceObject.GridItem, {
        col: isMobile ? GRID_FULL_WIDTH : GRID_COLS_TERTIARY_BLOCK[validatedColumns],
        className: "".concat(HeroSection_namespace, "__value-props-container cols-").concat(validatedColumns)
      }, void 0, valuePropsComponent)), validatedColumns !== 3 && !!valueProps && (valueProps === null || valueProps === void 0 ? void 0 : valueProps.columns) >= 3 && !isMobile && /*#__PURE__*/jsx_default()(layout_namespaceObject.Grid, {
        container: true,
        component: "div",
        className: external_classnames_default()(HeroSection_namespace, className, isMobile ? "".concat(HeroSection_namespace, "--mobile") : "".concat(HeroSection_namespace, "--desktop"))
      }, void 0, /*#__PURE__*/jsx_default()(layout_namespaceObject.GridItem, {
        col: GRID_FULL_WIDTH
      }, void 0, /*#__PURE__*/jsx_default()("div", {
        className: "".concat(HeroSection_namespace, "__value-props-container-horizontal")
      }, void 0, valuePropsComponent)))]
    }))
  }));
};

/**
 * Prop types
 */

HeroSection.defaultProps = {
  id: null,
  className: '',
  isMobile: false,
  isWebView: false,
  andesTheme: themes.THEMES.MP,
  head: {
    title: ''
  },
  asset: null,
  columns: 2,
  background: {
    type: 'hero'
  },
  actions: null,
  margins: null,
  valueStatement: null,
  complementaryInformation: '',
  form: null,
  countdown: null,
  tracking: null
};

/**
 * Export component
 */
/* harmony default export */ const src_HeroSection = (HeroSection);
;// ./packages/heroSection/src/HeroSection.js

/* harmony default export */ const heroSection_src_HeroSection = (src_HeroSection);
;// ./packages/heroSection/index.js
/**
 * Export Component
 */

/* harmony default export */ const heroSection = (heroSection_src_HeroSection);
})();

module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=index.production.js.map